<template>
	<div class="calendar-container">
		<div v-if="!$vuetify.breakpoint.smAndDown" :style="mini ? 'width: 60px':'width: 300px'">
			<v-navigation-drawer
				v-model="drawer"
				:mini-variant="mini"
				width="100%"
				height="calc(100vh - 140px)"
				color="#FAFAFA"
				permanent
			>
				<template v-if="!mini">
					<v-date-picker 
						v-model="picker"
						:color="'rgba(129, 204, 0, 0.5)'"
						:show-current="currentDate"
						no-title
						full-width
						show-adjacent-months
						@change="onDataPickerChanged($event)"
					>
					</v-date-picker>
					<div class="date-picker-task-wrap" style="height: calc(100vh - 474px)">
						<div class="date-picker-task-container">
							<CalendarPanel
								:assignItems="assignItems"
								:assignedTo="assigned_to"
								:colorCalendars="color_calendars"
								:color="color"
								:calendar="calendar"
								@selected="onCalendarsClick($event)"
								@calendar="$emit('calendar', $event)"
							/>
							<v-progress-linear v-if="loading_worklist" indeterminate rounded height="5" style="width: 90%" class="mt-1 mx-4" :color="color"></v-progress-linear>
							<div v-for="worklist in worklists" :key="worklist.id" class="flex-column mx-4 my-1">
								<div class="date-picker-task-row px-1" :class="getWorklistClass(worklist.id) ? 'date-picker-task-row-red':'date-picker-task-row-grey'" @click="onOpenTasklist(worklist.id, worklist.settings)">
									<div class="date-picker-task-row-left">
										<v-icon v-if="worklist_open_id === worklist.id" :color="getWorklistClass(worklist.id) ? '#F45252':color">mdi-chevron-up</v-icon>
										<v-icon v-else :color="getWorklistClass(worklist.id) ? '#F45252':''">mdi-chevron-down</v-icon>
										<v-text-field
											style="width: 100%"
											v-if="edit_id === worklist.id"
											:value="worklist.name"
											:color="color"
											background-color="#FFFFFF"
											outlined
											dense
											hide-details
											@click.stop
											@blur="onBlur($event, worklist)"
											@keydown="onKeyDown($event, worklist)"
										></v-text-field>
										<div class="data-picker-task-name-text" v-else :class="worklist_open_id === worklist.id ? (getWorklistClass(worklist.id) ? 'task-new-color':'task-opened-color') :''">{{ worklist.name }}</div>
									</div>
									<TaskMenu
										v-if="!getWorklistClass(worklist.id)"
										:key="worklist.id"
										:isOwned="worklist.is_owned"
										:isPinned="worklist.is_pinned"
										:color="worklist_open_id === worklist.id ? color: 'rgba(25, 42, 62, 0.7)'"
										@click-menu-item="onClickMenuItem($event, worklist)"
										@delete="onDeleteMenuTasklist(worklist)"
									/>
								</div>
								<v-btn v-if="getWorklistClass(worklist.id) && worklist_open_id === worklist.id" block color="red" class="white--text text-capitalize" @click="onSaveChange(worklist)">
									<span v-if="worklist.id.startsWith('0')">Save list</span>
									<span v-else>Save changes</span>
								</v-btn>
								<v-progress-linear v-if="loading_tasklist === worklist.id" indeterminate rounded height="3" style="width: 100%" class="mt-1" :color="color"></v-progress-linear>
								<div v-if="worklist_open_id === worklist.id">
									<div class="date-picker-top my-1">
										<v-text-field
											class="date-picker-filter-item"
											v-model="taskname_key"
											:color="color"
											background-color="#FFFFFF"
											dense
											outlined
											clearable
											hide-details
											placeholder="Search"
											@change="onFilterChange(worklist)"
										>
											<template v-slot:prepend-inner>
												<v-icon color="rgba(25, 42, 62, 0.7)">mdi-magnify</v-icon>
											</template>
										</v-text-field>
										<FirstList class="ml-2 task-menu-item" color="rgba(25, 42, 62, 0.7)" width="24" height="24" @click="is_show_filter_icons = !is_show_filter_icons"/>
									</div>
									<div v-if="is_show_filter_icons" class="date-picker-filter pr-7">
										<div class="date-picker-filter-item">
											<SuitCase class="mr-2" color="#81CC00" width="20" height="20"/>
											<v-select
												v-model="job_selected"
												:background-color="color"
												:color="color"
												:items="job_items"
												item-text="display_name"
												item-value="id"
												item-color="success"
												return-object
												solo
												flat
												dense
												hide-details
												multiple
												dark
												attach
												@change="onFilterChange(worklist)"
											>
												<template v-slot:label>
													<span style="color: #FFFFFF; font-weight: 500;">Job</span>
												</template>
												<template v-slot:append>
													<v-icon style="color: #FFFFFF; font-weight: 500;">mdi-chevron-down</v-icon>
												</template>
												<template v-slot:selection="{ index }">
													<span style="padding-top: 2px" v-if="index === 0">Job</span>
												</template>
											</v-select>
										</div>
										<div class="date-picker-filter-item mt-3">
											<FirstList class="mr-2" color="#81CC00" width="20" height="20"/>
											<v-select
												v-model="client_selected"
												:background-color="color"
												:color="color"
												:items="client_items"
												item-text="display_name"
												item-value="id"
												item-color="success"
												append-icon="mdi-chevron-down"
												return-object
												solo
												flat
												dense
												hide-details
												multiple
												dark
												attach
												@change="onFilterChange(worklist)"
											>
												<template v-slot:label>
													<span style="color: #FFFFFF; font-weight: 500;">Client</span>
												</template>
												<template v-slot:append>
													<v-icon style="color: #FFFFFF; font-weight: 500;">mdi-chevron-down</v-icon>
												</template>
												<template v-slot:selection="{ index }">
													<span style="padding-top: 2px" v-if="index === 0">Client</span>
												</template>
											</v-select>
										</div>
										<div class="date-picker-filter-item mt-3">
											<v-icon class="mr-1" dense color="#81CC00">mdi-check</v-icon>
											<v-select
												v-model="statuses_selected"
												:background-color="color"
												:color="color"
												:items="statusses"
												item-text="desc"
												item-value="id"
												item-color="success"
												append-icon="mdi-chevron-down"
												return-object
												solo
												flat
												dense
												hide-details
												multiple
												dark
												attach
												@change="onFilterChange(worklist)"
											>
												<template v-slot:label>
													<span style="color: #FFFFFF; font-weight: 500;">Task status</span>
												</template>
												<template v-slot:append>
													<v-icon style="color: #FFFFFF; font-weight: 500;">mdi-chevron-down</v-icon>
												</template>
												<template v-slot:selection="{ index }">
													<span style="padding-top: 2px" v-if="index === 0">Task status</span>
												</template>
											</v-select>
										</div>
									</div>
									<div v-for="task in worklist.tasks" :key="task.id" class="mt-1">
										<CalendarItem
											:key="task.id" 
											:task="task"
											:statuses="statusses"
											:isPrivilege="isPrivilege"
											:privileges="privileges"
											:jobValid="task.job_valid"
											:taskWorkday="task_workday"
											@edit="onEditMenuItem($event)"
											@additem="onAdditemMenuItem($event, false)"
											@find="onFindTimesheetMenuItem($event)"
											@share="onShareMenuItem($event)"
											@delete="onDeleteMenuItem($event, false, worklist)"
											@duplicate="onDuplicateMenuItem($event, false, worklist)"
											@status="onStatusChange($event, false, worklist)"
											@subtask="onCreateSubTask($event, false, worklist)"
											@log-time="logtime_task_id = $event"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
				<template v-slot:prepend>
					<div>
						<v-btn v-if="!mini" width="24" height="24" class="float-right my-2 mx-4" depressed fab color="#E8EAEC" @click.stop="onMenuClick()">
							<DoubleArrowRight color="rgba(25, 42, 62, 0.7)" />
						</v-btn>
						<v-btn v-if="mini" width="24" height="24" class="float-right my-2 mx-4" depressed fab color="#E8EAEC" @click.stop="onMenuClick()">
							<DoubleArrowLeft color="rgba(25, 42, 62, 0.7)" />
						</v-btn>
					</div>
				</template>
			</v-navigation-drawer>
		</div>
		<div class="calendar pa-4 mt-0" :style="$vuetify.breakpoint.smAndDown ? 'width: 100%':(mini ? 'width: calc(100% - 60px)': 'width: calc(100% - 300px)')" :cols="$vuetify.breakpoint.smAndDown ? 12: (mini ? 11:10)">	
			<v-alert type="error" v-if="error_msg.length !== 0">
				{{ errorMessageFormat(error_msg) }}
			</v-alert>
			<template v-if="$vuetify.breakpoint.smAndDown">
				<v-row justify="space-between" class="mb-2 px-1">
					<v-btn
						icon
						small
						color="grey darken-2"
						@click="prev()"
					>
						<v-icon>
							mdi-chevron-left
						</v-icon>
					</v-btn>
					<v-btn depressed outlined height="32" class="text-capitalize mr-2 date-text" @click="onChangeToToday()">Today</v-btn>
					<div class="date-title">{{ titleDate }}</div>
					<v-btn
						icon
						small
						color="grey darken-2"
						@click="next()"
					>
						<v-icon>
							mdi-chevron-right
						</v-icon>
					</v-btn>
				</v-row>
			</template>
			<template v-else>
				<div class="calendar-toolbar">
					<div class="calendar-date">
						<v-btn
							icon
							small
							color="grey darken-2"
							@click="prev()"
						>
							<v-icon>
								mdi-chevron-left
							</v-icon>
						</v-btn>
						<v-btn depressed outlined height="32" class="text-capitalize mr-2 date-text" @click="onChangeToToday()">Today</v-btn>
						<div class="date-title">{{ titleDate }}</div>
						<v-btn
							icon
							small
							color="grey darken-2"
							@click="next()"
						>
							<v-icon>
								mdi-chevron-right
							</v-icon>
						</v-btn>
					</div>
				</div>
			</template>
			<ProgressLinear v-if="loading"/>
			<v-row class="mt-0">
				<v-col>
					<v-sheet height="calc(100vh - 200px)">
						<v-calendar
							ref="calendar"
							v-model="calendar_date"
							:type="types_select"
							:weekdays="types_select === 'custom-daily' ? custom_weekdays:weekdays"
							:events="events"
							event-color="white"
							event-name="title"
							event-start="start_date"
							event-end="end_date"
							:event-height="types_select !== 'month' ? calendar_item_height : 24"
							:interval-height="calendar_item_height * 2"
							:event-ripple="false"
							:start="start_custom_weekly"
							:end="end_custom_weekly"
							:interval-style="intervalStyle"
							:interval-minutes="calendar_duration"
							:interval-count="(24*60)/calendar_duration"
							event-overlap-mode="column"
							@click:more="onMoreClick"
							@click:event="showEvent"
							@mousedown:event="startDrag"
							@mousedown:time="startTime"
							@mousedown:day="startDay"
							@mousemove:time="mouseMove"
							@mousemove:day="mouseMoveDay"
							@mouseup:time="endDrag"
							@mouseup:day="endDragDay"
							@mouseleave.native="cancelDrag"
						>
							<template v-slot:event="{event, timed}">
								<v-menu v-if="event.type === event_task" offset-y offset-x nudge-left="200" max-width="300">
									<template v-slot:activator="{ on, attrs }">
										<div v-bind="attrs" v-on="on" @click.stop class="item-container task-item-container"
											:class="getTaskClass(event)"
											:style="getTaskStyle(event)">
											<v-tooltip v-if="event.actual > event.budget" :color="event.budget === 0 ? '#82899B':'error'" right>
												<template v-slot:activator="{ on, attrs }">
													<div :class="event.budget === 0 ? 'corner-grey':'corner'" v-bind="attrs" v-on="on"></div>
												</template>
												<span v-if="event.budget !== 0">Task is over Budget</span>
												<span v-if="event.budget === 0">No Budget</span><br>
												<span>{{ _minutesToBudget(event.actual) }} of {{ _minutesToBudget(event.budget) }}</span>
											</v-tooltip>
											<v-row v-if="!$vuetify.breakpoint.smAndDown && types_select !== 'month'" class="item-container-inside" no-gutters>
												<v-col cols="11" class="pr-1">
													<div class="text-title">{{ event.title}}</div>
													<v-card v-if="event.start_time.length !== 0 && (types_select === 'day' || types_select === 'week' || types_select === 'custom-daily')" style="overflow: hidden" flat tile :color="event.color" :max-height="((event.duration / calendar_duration) * calendar_item_height * 2) - 8 - (14*2)">
														<div class="text-name-full" :style="`color: ${formatColor(event.color)}`">{{ event.job.code}}&nbsp;{{event.job.name}}</div>
													</v-card>
													<div v-else class="text-name">{{ event.job.code}}&nbsp;{{event.job.name}}</div>
													<div class="calendar-toolbar">
														<div class="text-name-style">
															<span v-if="event.start_time.length === 0"></span>
															<span v-if="event.start_time.length !== 0">{{ event.start_time }}&nbsp;-&nbsp;{{ event.end_time }}</span>
														</div>
														<div class="text-name-style">{{ event.budget_left }}</div>
													</div>
												</v-col>
												<v-col cols="1" class="item-container-icons">
													<TimeSheet
														v-if="event.status.type !== status_completed_type && event.job_valid"
														class="task-menu-item task-menu-item-able"
														:color="formatColor(event.color)"
														width="20"
														height="20"
														@click="onLogTime(event.id)" />
													<v-icon v-if="event.status.type === status_completed_type" dense class="menu-disable">mdi-check</v-icon>
													<CalendarItemMenu
														:key="event.id" 
														:type="event_task"
														:hasChild="event.has_child"
														:color="formatColor(event.color)"
														:privileges="privileges"
														:isPrivilege="isPrivilege"
														:isCompleted="event.status.type === status_completed_type"
														@click-menu-item="onClickTaskMenuItem($event, event)"
														@delete="onDeleteMenuItem(event)"
														@click.stop
													/>
												</v-col>
											</v-row>
											<v-card v-if="$vuetify.breakpoint.smAndDown || types_select === 'month'" elevation="0" color="transparent">
												<div>{{ event.job.code}}&nbsp;-&nbsp;{{ event.title }}</div>
											</v-card>
										</div>
									</template>
									<CalendarItem
										class="task-card"
										:key="event.id" 
										:task="event"
										:statuses="statusses"
										:isPrivilege="isPrivilege"
										:privileges="privileges"
										:jobValid="event.job_valid"
										:taskWorkday="task_workday"
										@click.stop
										@edit="onEditMenuItem($event)"
										@additem="onAdditemMenuItem($event)"
										@find="onFindTimesheetMenuItem($event)"
										@share="onShareMenuItem($event)"
										@delete="onDeleteMenuItem($event)"
										@duplicate="onDuplicateMenuItem($event)"
										@status="onStatusChange($event)"
										@subtask="onCreateSubTask($event)"
										@log-time="logtime_task_id = $event"
									/>
								</v-menu>
								<v-menu v-if="event.type === event_timesheet" offset-y offset-x nudge-left="200" max-width="300">
									<template v-slot:activator="{ on, attrs }">
										<div v-bind="attrs" v-on="on" class="item-container timesheet-item-container" :class="privileges.includes(ts) && event.job_valid ? (mousedownFired ? 'drag-able': '') :'drag-disable'">
											<v-row class="item-container-inside" no-gutters>
												<v-col v-if="!$vuetify.breakpoint.smAndDown && types_select !== 'month'" cols="11" class="pr-1">
													<div class="text-title" >
														<span v-if="event.task">{{ event.task.display_name }}</span>
														<span v-if="!event.task">{{ event.kind.display_name }}</span>
													</div>
													<div v-if="!event.start" class="text-name">{{ event.job.code }} {{ event.job.display_name }}</div>
													<v-card v-if="event.start" style="overflow: hidden" flat tile color="#E1EFF5" :max-height="((event.duration / calendar_duration) * calendar_item_height * 2) - 8 - (14*2)">
														<div class="text-name-full" style="color: #3A7E9F">{{ event.job.code }} {{ event.job.display_name }}</div>
													</v-card>
													<div class="text-name">{{ event.duration_fmt }}</div>
												</v-col>
												<v-card v-if="$vuetify.breakpoint.smAndDown || types_select === 'month'" elevation="0" color="transparent" style="justify-content: start">
													<div>
														<span class="mr-1">{{ event.duration_fmt}}</span>
														<span v-if="event.task">{{ event.task.display_name}}</span>
														<span v-if="!event.task">{{ event.kind.display_name }}</span>
													</div>
												</v-card>
												<v-col v-if="!$vuetify.breakpoint.smAndDown && types_select !== 'month'" cols="1" class="item-container-icons">
													<CalendarItemMenu
														v-if="event.job_valid"
														@click.stop
														:type="event_timesheet"
														:color="'#65A3C1'"
														:privileges="privileges"
														@click-menu-item="onClickTimesheetMenuItem($event, event)"
														@delete="onDeleteTimesheet(event)"/>
												</v-col>
											</v-row>
										</div>
									</template>
									<CalendarTimesheetItem
										:timesheet="event"
										:privileges="privileges"
										@duplicate="onClickTimesheetMenuItem('duplicate', event)"
										@click-menu-item="onClickTimesheetMenuItem($event, event)"
										@delete="onDeleteTimesheet(event)"/>
								</v-menu>
								<v-menu v-if="event.type === event_leave" offset-y offset-x nudge-left="200" max-width="300">
									<template v-slot:activator="{ on, attrs }">
										<div v-bind="attrs" v-on="on" class="item-container leave-item-container" :class="getLeaveClass(event)">
											<v-row v-if="!$vuetify.breakpoint.smAndDown && types_select !== 'month'" class="item-container-inside" no-gutters>
												<v-col v-if="!$vuetify.breakpoint.smAndDown && types_select !== 'month'" cols="11">
													<div class="text-title" style="line-height: 12px;">{{ event.type_desc }}</div>
													<div v-if="!event.leave_approved" class="text-name" style="line-height: 12px;">Pending approval</div>
													<div class="text-title" style="line-height: 12px;">{{ event.duration_fmt }}</div>
												</v-col>
												<v-col v-if="!$vuetify.breakpoint.smAndDown && types_select !== 'month'" cols="1" class="item-container-icons">
													<CalendarItemMenu
														v-if="!event.leave_paid"
														:type="event_leave"
														:color="'#FFFFFF'"
														:privileges="privileges"
														:isApproved="event.leave_approved"
														:isPaid="event.leave_paid"
														:isPartPaid="event.pay_processed"
														@click-menu-item="onClickLeaveMenuItem($event, event)"
														@delete="onDeleteLeave(event)"
														@click.stop/>
												</v-col>
											</v-row>
											<v-card v-if="$vuetify.breakpoint.smAndDown || types_select === 'month'" elevation="0" color="transparent" style="justify-content: start">
												<div style="line-height: 12px; color: #FFFFFF">{{ event.duration_fmt }}&nbsp;&nbsp;{{ event.type_desc }}</div>
											</v-card>	
										</div>
									</template>
									<CalendarLeaveItem
										class="task-card"
										:leave="event"
										:color="'#C18014'"
										:privileges="privileges"
										:isCurrentUser="userAddressId === event.employee_id"
										@click-menu-item="onClickLeaveMenuItem($event, event)"
										@delete-leave="onDeleteLeave(event)"
									/>
								</v-menu>
								<v-menu v-if="event.type === event_item" offset-y offset-x nudge-left="200" max-width="300">
									<template v-slot:activator="{ on, attrs }">
										<div v-bind="attrs" v-on="on" class="item-container item-item-container drag-disable">
											<v-row class="item-container-inside" no-gutters>
												<v-col v-if="!$vuetify.breakpoint.smAndDown && types_select !== 'month'" cols="11" class="pr-1 task-menu-item-able">
													<div class="text-title">
														<span>{{ event.units }}</span>
														<span class="ml-2">{{ event.kind.display_name }}</span>
													</div>
													<div class="text-name" style="color: #0012B1">{{ event.job.code }} {{ event.job.display_name }}</div>
												</v-col>
												<v-card v-if="$vuetify.breakpoint.smAndDown || types_select === 'month'" elevation="0" color="transparent" style="justify-content: start">
													<div style="color: #0012B1">
														<span class="mr-1">{{ event.units }}</span>
														<span>{{ event.kind.display_name }}</span>
													</div>
												</v-card>
												<v-col v-if="!$vuetify.breakpoint.smAndDown && types_select !== 'month'" cols="1" class="item-container-icons">
													<CalendarItemMenu
														@click.stop
														:type="event_item"
														:color="'#0012B1'"
														:privileges="privileges"
														@click-menu-item="onClickItemMenuItem($event, event)"
														@delete="onDeleteItemMenuItem(event)"/>
												</v-col>
											</v-row>
										</div>
									</template>
									<CalendarItemsItem
										class="task-card"
										:item="event"
										:privileges="privileges"
										@click-menu-item="onClickItemMenuItem($event, event)"
										@delete="onDeleteItemMenuItem(event)"
									/>
								</v-menu>
								<v-menu v-if="event.type === event_holiday" offset-y offset-x nudge-left="200" max-width="300">
									<template v-slot:activator="{ on, attrs }">
										<div v-bind="attrs" v-on="on" class="item-container holiday-item-container" :class="getLeaveClass(event)">
											<v-row class="item-container-inside" no-gutters>
												<v-col v-if="!$vuetify.breakpoint.smAndDown && types_select !== 'month'" cols="1">
													<div>
														<LeaveIcon class="mt-1" :color="'#FFB946'" width="20" height="20"/>
													</div>
												</v-col>
												<v-col v-if="!$vuetify.breakpoint.smAndDown && types_select !== 'month'" cols="10" class="pl-2">
													<div class="text-title mt-1">{{ event.type_desc }}</div>
												</v-col>
												<v-col v-if="!$vuetify.breakpoint.smAndDown && types_select !== 'month'" cols="1" class="item-container-icons">
													<CalendarItemMenu
														v-if="!event.leave_paid"
														@click.stop
														:type="event_holiday"
														:color="'#FFB946'"
														:privileges="privileges"
														:isApproved="event.leave_approved"
														:isPaid="event.leave_paid"
														@click-menu-item="onClickHolidayMenuItem($event, event)"
														@delete="onDeleteHoliday(event)"/>
												</v-col>
												<v-card v-if="$vuetify.breakpoint.smAndDown || types_select === 'month'" elevation="0" color="transparent" style="justify-content: start">
													<v-row class="ma-0">
														<LeaveIcon :color="'#FFB946'" width="16" height="16" class="mr-1"/>
														<span style="line-height: 14px;">{{ event.type_desc }}</span>
													</v-row>
												</v-card>
											</v-row>
										</div>
									</template>
									<CalendarPHolidayItem
										:eventObject="event"
										:color="'#FFB946'"
										:privileges="privileges"
										@click-menu-item="onClickHolidayMenuItem($event, event)"
										@delete="onDeleteHoliday(event)"/>
								</v-menu>
								<v-menu v-if="event.type === event_events" offset-y offset-x nudge-left="200" max-width="300">
									<template v-slot:activator="{ on, attrs }">
										<div v-bind="attrs" v-on="on" class="item-container event-item-container drag-able">
											<v-row class="item-container-inside" no-gutters>
												<v-col v-if="!$vuetify.breakpoint.smAndDown && types_select !== 'month'" cols="1">
													<div>
														<CalendarIcon :color="color" width="20" height="20"/>
													</div>
												</v-col>
												<v-col v-if="!$vuetify.breakpoint.smAndDown && types_select !== 'month'" cols="10" class="pl-2">
													<div class="text-title">{{ event.description }}</div>
													<div v-if="event.job" :class="event.all_day ? 'text-name':'text-name-full'">{{ event.job.code }} {{ event.job.display_name }}</div>
												</v-col>
												<v-col v-if="!$vuetify.breakpoint.smAndDown && types_select !== 'month'" cols="1" class="item-container-icons">
													<CalendarItemMenu
														@click.stop
														:type="event_events"
														:color="'#192A3E'"
														:privileges="privileges"
														:isIncludingJob="event.job !== null"
														:isInviteMultiple="event.event_type.can_invitemultiple"
														:isCreatByOther="event.organiser.id !== userAddressId"
														@click-menu-item="onClickEventMenuItem($event, event)"
														@delete="onDeleteEvent(event)"/>
												</v-col>
												<v-card v-if="$vuetify.breakpoint.smAndDown || types_select === 'month'" elevation="0" color="transparent" style="justify-content: start;">
													<div style="line-height: 12px; color: #192A3E">{{ event.description }}</div>
												</v-card>
											</v-row>
										</div>
									</template>
									<CalendarEventItem
										:eventObject="event"
										:color="color"
										:privileges="privileges"
										:isCreatByOther="event.organiser.id !== userAddressId"
										@click-menu-item="onClickEventMenuItem($event, event)"
										@delete="onDeleteEvent(event)"/>
								</v-menu>
								<div
									v-if="timed && !$vuetify.breakpoint.smAndDown && isExtendBottom(event)"
									class="v-event-drag-bottom"
									@mousedown.stop="extendBottom(event)"
								></div>
							</template>
							<template v-slot:day-body="{ date }">
								<div
									v-if="date === currentDate"
									class="current-time"
									:class="{ first: date === currentDate }"
									:style="{ top: nowY }"
								></div>
							</template>
							<template v-slot:day-label-header="{ date, day }">
								<CalendarCapacityBar
									:date="date"
									:day="day"
									:calendarDate="calendar_date"
									:currentDate="currentDate"
									:progressByDate="progress_by_date"
									:assignedTo="assigned_to"
									:color="color"
									:colors="colors"
								/>
							</template>
							<template v-slot:day-label="{ date, day }">
								<CalendarCapacityBar
									:date="date"
									:day="day"
									:calendarDate="calendar_date"
									:currentDate="currentDate"
									:progressByDate="progress_by_date"
									:assignedTo="assigned_to"
									:color="color"
									:colors="colors"
								/>
							</template>
						</v-calendar>
						<v-menu
							v-if="moreOpen"
							v-model="moreOpen"
							:close-on-content-click="false"
							:activator="moreElement"
							offset-x
							min-width="268px"
							max-width="300px"
						>
							<v-card
								color="grey lighten-4"
								min-width="268px"
								max-width="300px"
								class="py-1"
								flat
							>
								<div v-for="(event, index) of moreEvent" :key="event.id" class="pl-1" :class="index !== moreEvent.length -1 ? 'mb-1':''">
									<v-row v-if="event.type === event_task" :align="`center`" class="calendar-toolbar task-menu-item ma-0" :class="event.job_valid ? 'task-menu-item-able':''" style="align-items: flex-start" :style="!event.job_valid ? 'padding: 3px 0' : ''" @click.stop="showTaskDetails(event)">
										<v-col cols="10" class="task-item-text-title">
											<div class="text-name">{{ event.title }}</div>
											<div class="text-name task-item-text-title-oneline">{{ event.job.code }}&nbsp;-&nbsp;{{ event.job.name }}</div>
											<div class="text-name">{{ event.budget_left }}</div>
										</v-col>
										<v-col cols="2" class="mr-2 calendar-date">
											<TimeSheet v-if="event.status.type !== status_completed_type && event.job_valid" color="rgba(0, 0, 0, 0.54)" width="20" height="20" @click="onLogTime(event.id)"/>
											<v-icon v-if="event.status.type === status_completed_type" dense>mdi-check</v-icon>
										</v-col>
									</v-row>
									<div v-if="event.type === event_timesheet" class="icon-container date-picker-filter-item task-menu-item" :class="event.job_valid ? 'task-menu-item-able':''" style="padding: 3px 0;" @click.stop="showTimesheetDetails(event)">
										<div>
											<span class="text-name timesheet-text-color">{{ _minutesToBudget(event.duration)}}&nbsp;&nbsp;</span>
											<span class="text-name timesheet-text-color" v-if="event.task">{{ event.task.display_name}}</span>
											<span class="text-name timesheet-text-color" v-if="!event.task">{{ event.kind.display_name }}</span>
										</div>
										<div class="text-name timesheet-text-color">{{ event.job.code }}&nbsp;-&nbsp;{{ event.job.display_name }}</div>
									</div>
									<div v-if="event.type === event_leave" class="date-picker-filter-item task-menu-item task-menu-item-able" @click.stop="showLeaveDetails(event)">
										<span class="task-item-text-title leave-text-color" :style="event.leave_approved ? 'font-weight: 500': ''">{{ _minutesToBudget(event.duration)}}&nbsp;&nbsp;{{ event.type_desc }}<span v-if="!event.leave_approved">&nbsp;(pending)</span></span>
									</div>
									<div v-if="event.type === event_holiday" class="date-picker-filter-item task-menu-item task-menu-item-able" @click.stop="showPublicHolidayDetails(event)">
										<span class="task-item-text-title public-text-color" :style="event.leave_approved ? 'font-weight: 500': ''">{{ event.type_desc }}</span>
									</div>
									<div v-if="event.type === event_item" class="date-picker-filter-item task-menu-item task-menu-item-able" @click.stop="showItemDetails(event)">
										<span class="task-item-text-title item-text-color">{{ event.units }}&nbsp;&nbsp;{{ event.kind.display_name }}</span>
									</div>
									<div v-if="event.type === event_events" class="date-picker-filter-item task-menu-item task-menu-item-able" @click.stop="showEventDetails(event)">
										<span v-if="!event.all_day" class="task-item-text-title event-text-color">{{ _minutesToBudget(event.duration)}}&nbsp;&nbsp;</span>
										<span class="task-item-text-title event-text-color">{{ event.description }}</span>
									</div>
								</div>
							</v-card>
						</v-menu>
						<v-menu
							v-model="selectedOpen"
							:close-on-content-click="false"
							:activator="selectedElement"
							offset-x
							min-width="268px"
							max-width="300px"
						>
							<CalendarItemsItem
								class="task-card"
								:item="selectedEvent"
								:privileges="privileges"
							/>
						</v-menu>
					</v-sheet>
				</v-col>
			</v-row>
		</div>
		<v-dialog
			v-if="task_detail_visible"
			v-model="task_detail_visible"
			persistent
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs : width"
		>
			<TaskDetail 
				:color="color"
				:task="task_detail_item"
				@find-ts="find_timesheet_id = $event"
				@task-copy="onDuplicateMenuItem($event)"
				@task-sub="onCreateSubTask($event)"
				@task-close="onTaskClose()"
			/>
		</v-dialog>
		<v-dialog
			v-if="task_create_visible"
			v-model="task_create_visible"
			persistent
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs : width"
		>
			<TaskCreation 
				:color="color"
				:taskDetail="task_detail_item"
				:isSubTaskCreation="isSubTaskCreation"
				:isDuplication="isDuplication"
				@close="onTaskClose(update_worklist ? update_worklist : null)"
			/>
		</v-dialog>
		<v-dialog
			v-if="timesheet_create_visible"
			v-model="timesheet_create_visible"
			persistent
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs : width"
		>
			<EditTimesheet 
				:isLogTimesheet="true"
				:tasid="timesheet_create_task_id"
				@cancel-timesheet="onTaskClose()"
			/>
		</v-dialog>
		<v-dialog
			v-if="timesheet_detail_visible"
			v-model="timesheet_detail_visible"
			persistent
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs : width"
		>
			<EditTimesheet
				:editItem="timesheet_detail_item"
				:isAddTimesheet="isAddTimesheet"
				:isLogTimesheet="true"
				@cancel-timesheet="onTaskClose()"
			/>
		</v-dialog>
		<v-dialog
			v-if="item_detail_visible"
			v-model="item_detail_visible"
			persistent
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs : width"
		>
			<EditItems
				:color="color"
				:item="item_detail_item"
				:isDuplication="isItemDuplication"
				@close="onTaskClose()"
			/>
		</v-dialog>
		<v-dialog
			v-if="event_detail_visible"
			v-model="event_detail_visible"
			persistent
			:retain-focus="false"
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs : width"
		>
			<EditEvents
				:color="color"
				:editEventItem="event_detail_item"
				:isEdit="!isEventDuplication"
				:isDuplication="isEventDuplication"
				@close="onTaskClose()"
			/>
		</v-dialog>
		<v-dialog
			v-if="holiday_detail_visible"
			v-model="holiday_detail_visible"
			persistent
			:retain-focus="false"
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs : width"
		>
			<EditHoliday
				:color="color"
				:editEventItem="holiday_detail_item"
				:isEdit="true"
				@close="onTaskClose()"
			/>
		</v-dialog>
		<v-dialog
			v-if="add_timesheet_visible" 
			v-model="add_timesheet_visible" 
			persistent
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs: width"
		>
			<EditTimesheet :isAddTimesheet="true" :job="add_timesheet_job" @cancel-timesheet="onTaskClose()"/>
		</v-dialog>
		<ListTimesheetDialog
			v-if="find_timesheet_id !== 0"
			:visible="find_timesheet_id !== 0"
			:maxWidth="$vuetify.breakpoint.width * 0.85"
			:taskId="find_timesheet_id"
			@close="find_timesheet_id = 0"
			@openTs="timesheet_detail_item = $event; timesheet_detail_visible = true"
		/>
		<DeleteConfirmDialog 
			v-if="delete_visible"
			:visible="delete_visible" 
			:color="'error'"
			:title="`You are about to delete this ${delete_task.type}.`" 
			:content="`This action cannot be undone. Are you sure?`"
			:isMode="delete_task.type === event_events && delete_task.repeat"
			:ok="'Yes, delete'"
			:icon_name_title="'mdi-alert-circle'"
			:icon_name_front="'mdi-delete-outline'"
			:maxWidth="500"
			@cancel="onDeleteCancel()"
			@ok="onDelete($event)"
		/>
		<DeleteConfirmDialog 
			v-if="delete_tasklist_visible"
			:visible="delete_tasklist_visible" 
			:color="'error'"
			:title="`You are about to delete Tasklist ‘${delete_item.name}’`" 
			:content="'This action cannot be undone. Are you sure?'"
			:ok="'Yes, delete'"
			:icon_name_title="'mdi-alert-circle'"
			:icon_name_front="'mdi-delete-outline'"
			:maxWidth="500"
			@cancel="onDeleteTasklistCancel()"
			@ok="onDeleteTasklist()"
		/>
		<CalendarShareDialog 
			v-if="share_visible"
			:visible="share_visible"
			:taskId="share_task_id"
			@copy-link="onCopyLink($event)"
			@close="share_visible = false"
		/>
		<TaskShareDialog 
			v-if="share_tasklist_visible" 
			:visible="share_tasklist_visible" 
			:tasklistId="share_item.id"
			:tasklistAcl="share_item.acl ? share_item.acl : []"
			:tasklistOwner="share_item.owner"
			:color="color"
			@close="share_tasklist_visible = false"
			@copy-link="onCopyLink($event)"
		/>
		<TaskSaveAsDialog 
			v-if="save_as_visible" 
			:visible="save_as_visible" 
			:title_text="'Save tasklist as...'"
			:content_text="'New Tasklist name'"
			:confirm_button="'Save Tasklist'"
			:icon="save_icon"
			:color="color"
			:isDynamic="save_as_item && save_as_item.id === 0"
			@cancel="save_as_visible = false"
			@ok="onSaveAs($event)"
		/>
		<DialogNotice
			v-if="visible_notice" 
			:visible="visible_notice" 
			:text="notice_text"
			:color="notice_color"
		/>
		<ProgressCircular
			v-if="progress_visible" 
			:visible="progress_visible"
			:color="color"
			:note="`Duplicating`"
		/>
		<LogTimesheet
			v-if="logtime_task_id !== 0"
			:visible="logtime_task_id !== 0"
			:taskId="logtime_task_id" 
			:employeesId="userAddressId"
			@close="onLogTimesheetClose()"
		/>
		<v-dialog
			v-if="search_visible" 
			v-model="search_visible"
			persistent
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs : width"
		>
			<TaskSearch
				:statuses="statusses"
				:color="color"
				:id="search_item ? search_item.id : 0"
				:title="search_item ? search_item.name : 'Search Tasks'"
				:settings="search_item ? search_item.settings : null"
				@error-msg="error_msg = $event"
				@close="onCloseSearch()"
				@search="onSearch($event)"
			/>
		</v-dialog>
		<v-dialog
			v-if="dataPickerVisible" 
			v-model="dataPickerVisible"
			persistent
			fullscreen
		>
			<div class="data-picker-mobile-container">
				<v-row no-gutters :justify="'end'" class="px-3 pt-1">
					<v-icon right @click.stop="$emit('dataPickerVisible', false)">mdi-close</v-icon>
				</v-row>
				<v-date-picker 
					v-model="picker"
					:color="'rgba(129, 204, 0, 0.5)'"
					no-title
					full-width
					show-adjacent-months
					@change="onDataPickerChanged($event)"
				>
				</v-date-picker>
				<div class="date-picker-task-wrap">
					<div class="date-picker-task-container">
						<CalendarPanel
							:assignItems="assignItems"
							:assignedTo="assigned_to"
							:colorCalendars="color_calendars"
							:color="color"
							:calendar="calendar"
							@selected="onCalendarsClick($event)"
							@calendar="$emit('calendar', $event)"
						/>
					</div>
				</div>
			</div>
		</v-dialog>
		<TaskUnsavedDialog 
			v-if="unsaved_visible" 
			:visible="unsaved_visible" 
			:type="`warning`" 
			:title_text="`Unsaved changes in Tasklist`" 
			:content_text="`Do you want to save changes to this Tasklist?`"
			:confirm_button="`Save changes`"
			:cancel_button="`Don't save`"
			:icon_name="`mdi-check`"
			:maxWidth="500"
			@cancel="onTaskUnsavedCancel()"
			@ok="onSaveAll()"
		/>
		<EmailDialog
			v-if="email_visible" 
			:visible="email_visible"
			:color="color"
			:eventItem="event_detail_item"
			@cancel="email_visible = false"
			@send="onEmailSend($event, event_detail_item)"
		/>
		<DeleteConfirmDialog 
			v-if="drag_visible"
			:visible="drag_visible" 
			:color="'warning'"
			:title="`Task will be moved to the next working day.`" 
			:content="drag_msg"
			:ok="'Okay, move'"
			:icon_name_title="'mdi-alert-circle'"
			:maxWidth="500"
			@cancel="onCancelTaskDrag()"
			@ok="onTaskDrag(drag_event)"
		/>
	</div>
</template>
<script>
import TimeSheet from "@/components/icons/timesheet";
import SuitCase from "@/components/icons/suitcase.vue";
import FirstList from "@/components/icons/first_list";
import LeaveIcon from "@/components/icons/leave";
import CalendarIcon from "@/components/icons/calendar.vue";
import DoubleArrowLeft from "@/components/icons/double_arrow_left";
import DoubleArrowRight from "@/components/icons/double_arrow_right";
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import CalendarPanel from "@/views/timesheets/calendar_panel.vue";
import ProgressCircular from "@/components/dialogs/progress_dialog.vue";
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import CalendarItem from "@/views/timesheets/calendar_item.vue";
import CalendarItemsItem from "@/views/timesheets/calendar_items_item.vue";
import CalendarItemMenu from "@/views/timesheets/calendar_item_menu.vue";
import CalendarTimesheetItem from "@/views/timesheets/calendar_timesheet_item.vue";
import CalendarLeaveItem from "@/views/timesheets/calendar_leave_item.vue";
import CalendarPHolidayItem from "@/views/timesheets/calendar_pholiday_item.vue";
import CalendarEventItem from "@/views/timesheets/calendar_event_item.vue";
import CalendarCapacityBar from "@/views/timesheets/calendar_capacity_bar.vue";
import CalendarShareDialog from "@/views/timesheets/calendar_share_dialog.vue";
import TaskShareDialog from "@/views/tasks/task_share_dialog.vue";
import TaskSaveAsDialog from "@/views/tasks/task_save_as_dailog.vue";
import TaskDetail from "@/views/tasks/edit_task.vue";
import TaskCreation from "@/views/tasks/new_task.vue";
import EditTimesheet from "@/views/timesheets/new_timesheet.vue";
import EditItems from "@/views/items/new_item.vue";
import EditEvents from "@/views/events/new_event.vue";
import EditHoliday from "@/views/events/new_holiday.vue";
import LogTimesheet from "@/components/tasks/task_timesheet";
import DeleteConfirmDialog from "@/components/dialogs/delete_comfirm_dialog.vue";
import TaskMenu from "@/views/tasks/task_menu.vue";
import SaveIcon from "@/components/icons/save.vue";
import TaskSearch from "@/views/tasks/task_search.vue";
import TaskUnsavedDialog from "@/views/tasks/task_unsaved_dialog.vue";
import EmailDialog from "@/views/events/email_dialog.vue";
import ListTimesheetDialog from "@/views/timesheets/list_timesheet_dialog.vue";


import { colorContrastChecker } from '@/common/colorChecker.js';
import moment from 'moment';
import config from "@/config.js";

const TASKLIST_CLASS = 'restful.tasks.lists';

const Month_Key = 'month';
const Day_Key = 'day';

const Event_Weekends = 'weekends';
const Event_Events = 'events';
const Event_Task = 'task';
const Event_Timesheet = 'timesheet';
const Event_Leave = 'leave';
const Event_Item = 'item';
const Event_Holiday = 'holiday';

const Event_Task_Active = 'active_task';
const Event_Task_Completed = 'completed_task';

const Weekday = [1, 2, 3, 4, 5, 6, 0];
const Workday = [1, 2, 3, 4, 5];

const WeekOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

/*  suggested_mode, 0 - any, 1 = suggested, 2 = not suggested */
const NotSuggestedMode = 2;
const ACTIVE_STATUS = 2; /* according to meta, type=2 => 'Active' */

const TEXT_COLOR = config.text_color.default;
const SAVE_ICON = {
	name: SaveIcon,
	color: "white",
	width: 24, 
	height: 24,
};

const ALLEMPLOYEES = 2;
const ROLES = 1;
const DEPARTMENTS = 0;

const AssignTree = [
	{
		id: 2,
		name: 'Employees',
		children: [],
	},
	// {
	// 	id: 1,
	// 	name: 'Roles',
	// 	children: [],
	// },
	// {
	// 	id: 0,
	// 	name: 'Departments',
	// 	children: [],
	// }
];

const CurrentUserColor = 'rgba(25, 42, 62, 0.7)';
const CurrentUserEventColor = 'rgba(237,239,244)';

const SATURATION = 70;
const LIGHTNESS = 60;
const ALPHA = 1;

/* If selected, user will only be allow to amend items their own timesheets */
const TS = 'TS';
const JOr = 'JOr';

/** If selected the user can only modify events he/she owns (has created) */
const EVOwn = 'EVOwn';
/** If selected the user can manage and approve leave events */
const DAppLeave = 'DAppLeave';
/** If selected the user can manage public holidays */
const DPubHol = 'DPubHol';

/** the user will be able to change the scheduled dates within the traffic system */
const TrSc = 'TrSc';
const Date_Options_Suggested = 'suggested';
const Date_Options_Actual = 'actual';
const Date_Options_No = 'nodates';

const Calendar_Duration = 30;
const Calendar_Item_Height = 48;

/** some old task, the workday is empty, set the default value */
const Default_Workday = '1111100';

/** 0 = Not leave, 1 = Annual Leave, 2 = Personal leave, 3 = Public Holiday, 4 = Long service leave, 5 = Unpaid leave, 255 = Other leave */
const Not_Leave = 0;

/** 0-tentative, 1-busy, 2 - leave */
const Event_Type_Busy = 1;

/** 
 *  0 - not display job and adddress
 *  1 - display job and adddress, but no required
 *  2 - display adddress, required
 *  3 - display job and adddress, required
 */
const Mandatory = 2;
const Mandatory_Job = 3;


const Drag_MSG = 'is not a working day, so this task will be moved to';

export default {
	name: 'Calendar',
	model: {
		prop: 'dataPickerVisible',
		event: 'dataPickerVisible',
	},
	props: {
		dataPickerVisible: [Boolean],
		color: {
			type: String,
			default: ''
		},
		isPrivilege: {
			type: Boolean,
			default: true
		},
		privileges: {
			type: Array,
			default: () => [],
		},
		daysOfType: {
			type: Array,
			default: () => [],
		},
		viewOptions: {
			type: Array,
			default: () => [],
		},
		type: {
			type: String,
			default: ''
		},
		options: {
			type: Array,
			default: () => [],
		},
		display: {
			type: Array,
			default: () => [],
		},
		calendar: {
			type: Boolean,
			default: true
		},
		reload: {
			type: Boolean,
			default: false
		},
		calendarIndex: {
			type: Number,
			default: 0
		}
	},
	components: {
		CalendarItem,
		CalendarItemsItem,
		CalendarTimesheetItem,
		CalendarLeaveItem,
		CalendarPHolidayItem,
		CalendarEventItem,
		CalendarItemMenu,
		CalendarCapacityBar,
		TaskDetail,
		TaskCreation,
		EditTimesheet,
		EditItems,
		EditEvents,
		EditHoliday,
		ProgressLinear,
		ProgressCircular,
		CalendarPanel,
		CalendarShareDialog,
		DialogNotice,
		TimeSheet,
		SuitCase,
		FirstList,
		LeaveIcon,
		DoubleArrowLeft,
		DoubleArrowRight,
		LogTimesheet,
		DeleteConfirmDialog,
		TaskMenu,
		TaskShareDialog,
		TaskSaveAsDialog,
		TaskSearch,
		TaskUnsavedDialog,
		CalendarIcon,
		EmailDialog,
		ListTimesheetDialog
	},
	data() {
		this.status_completed_type = config.status_completed_type;
		this.event_events = Event_Events;
		this.event_task = Event_Task;
		this.event_timesheet = Event_Timesheet;
		this.event_leave = Event_Leave;
		this.event_item = Event_Item;
		this.event_holiday = Event_Holiday;
		this.save_icon = SAVE_ICON;
		this.maxWidth_xs = '100%';
		this.width = '800';
		this.ts = TS;
		this.calendar_duration = Calendar_Duration;
		this.calendar_item_height = Calendar_Item_Height;

		return {
			error_msg: '',
			loading: false,
			loading_worklist: false,
			loading_tasklist: 0,
			finish_timesheet_flag: false,
			statusses: [],
			user_timezone: '',

			drawer: null,
			mini: false,
			picker: moment().format('YYYY-MM-DD'),
			is_show_filter_icons: false,
			worklists: [],
			worklist_open_id: 0,

			job_items: [],
			job_selected: [],
			client_items: [],
			client_selected: [],
			statuses_selected: [],
			taskname_key: '',
			isShowPast: false,
			
			task_detail_item: null,
			task_detail_visible: false,
			task_create_visible: false,

			update_worklist: null,
			timesheet_detail_item: null,
			timesheet_detail_visible: false,
			timesheet_create_visible: false,
			timesheet_create_task_id: 0,
			find_timesheet_id: 0,
			add_timesheet_visible: false,
			add_timesheet_job: null,
			item_detail_item: null,
			item_detail_visible: false,
			event_detail_item: null,
			event_detail_visible: false,
			holiday_detail_item: null,
			holiday_detail_visible: false,
			delete_task: null,
			delete_visible: false,
			drag_visible: false,
			drag_msg: '',
			drag_event: null,

			share_task_id: 0,
			share_visible: false,
			progress_visible: false,
			logtime_task_id: 0,
			isAddTimesheet: false,
			isDuplication: false,
			isItemDuplication: false,
			isEventDuplication: false,
			email_visible: false,
			isSubTaskCreation: false,

			ready: false,
			weekdays: [],

			start_custom_weekly: moment().weekday(1).format('YYYY-MM-DD'),
			end_custom_weekly: moment().weekday(12).format('YYYY-MM-DD'),
			calendar_date: moment().format('YYYY-MM-DD'),
			work_time: [],
			task_workday: [],
			tasks: [],
			timesheets: [],
			timesheet_calculate: [],
			leaves: [],
			items: [],
			holidays: [],
			other_events: [],
			progress_by_date: null,
			workdays: [],
			job_invalid_status_ids: [],

			employees: [],
			types: this.$vuetify.breakpoint.smAndDown ? this.daysOfType.filter(t => { return t.value !== Month_Key }): this.daysOfType,
			types_select: this.$vuetify.breakpoint.smAndDown ? (this.type === Month_Key ? Day_Key : this.type) :this.type,
			view_options_select: this.options,

			moreOpen: false,
			moreEvent: {},
			moreElement: null,

			selectedEvent: {},
			selectedElement: null,
			selectedOpen: false,

			dragEvent: null,
			dragTime: null,
			dragDay: null,
			createEvent: null,
			createStart: null,
			extendOriginal: null,

			visible_notice: false,
			notice_text: [],
			tid: null,
			notice_color: '#00AAFD',

			/** 'mousedownFired' is used to solve the conflict between the click-event and the mousedown-event.
			 *  click event=mousedown => mouseup;
			 *  mousedown event=mousedown => mousemove => mouseup;
			 *  when 'mousemove', set mousedownFired=true;
			 *  if mousedownFired= true, click-event will not execute;
			 *  if mousedownFired= true, update-task will execute;
			 */
			mousedownFired: false,
			
			colors: ['#C18014', '#609800', '#3A7E9F', '#82899B', '#E8EAEC', '#9747FF'],
			category: ['scheduled', 'remaining'],

			delete_tasklist_visible: false,
			delete_item: null,

			share_tasklist_visible: false,
			share_item: { id: 0, acl: null, owner: { id: 0 } },

			edit_id: -1,

			save_as_visible: false,
			save_as_item: null,

			search_visible: false,
			search_item: null,
			current_unsaved_ids: [],

			unsaved_visible: false,

			assigned_to: this.display,
			assignItems: AssignTree,

			color_calendars: {},
			currentDate: moment().format('YYYY-MM-DD'),
			interval: null
		}
	},
	destroyed(){
		if(this.interval) {
			clearInterval(this.interval);;
		}
	},
	async created() {
		document.addEventListener("visibilitychange", () => {
			if (document.visibilityState === "visible") {
				this.getCurrentDate(true);
			}
		});

		this.interval = setInterval(() => this.getCurrentDate(), 2 * 3600 * 1000);

		this.initBasicSetting();
		await this.initSetupTime();
		await this.getStatusses();
		await this.getJobStatusIds();
		await this.getUserTimezone();

		// await this.getRoles();
		// await this.getDepartments();
		await this.getAllEmployees();

		this.initEevent();
	},
	mounted() {
		this.ready = true;
		this.scrollToTime();
		this.updateTime();

		this.getWorklist();
	},
	watch: {
		calendarIndex() {
			if (this.calendarIndex > 0) {
				this.initEevent();
			}
		},
		reload(newVal, oldVal) {
			if (newVal && !oldVal) {
				this.initEevent();
			}
		},
		type() {
			if (this.$vuetify.breakpoint.smAndDown) {
				this.types_select = this.type === Month_Key ? Day_Key : this.type;
			} else {
				this.types_select = this.type;
			}

			const date_range = this._setDateRange();
			this.start_custom_weekly = date_range.start_date;
			this.end_custom_weekly = date_range.end_date;

			this.initEevent();
		},
		options() {
			this.view_options_select = this.options;

			const date_range = this._setDateRange();
			const current_view = this.view_options_select.map(v => { return v.value });

			if (current_view.includes('weekends')) {
				this.weekdays = Weekday;
				this.start_custom_weekly = date_range.start_date;
				this.end_custom_weekly = date_range.end_date;
			}
			if (!current_view.includes('weekends')) {
				this.weekdays = Workday;
				this.start_custom_weekly = date_range.start_date;
				this.end_custom_weekly = date_range.end_date;
			}

			this.initEevent();
		},
		display() {
			this.assigned_to = this.display;
		},
		current_unsaved_ids(val, oldVal) {
			if (this.current_unsaved_ids.length !== 0 && val.length < oldVal.length) {
				const unsaved_tasklist = this.worklists.filter(t => { return t.id ===  this.current_unsaved_ids[0]});
				const unsaved_tasklist_other = this.other_worklists.filter(t => { return t.id ===  this.current_unsaved_ids[0]});
				const unsaved_arr = unsaved_tasklist.length !== 0 ? unsaved_tasklist : unsaved_tasklist_other;
				this.onSaveChange(unsaved_arr[0]);
			}
		}
	},
	computed: {
		events() {
			const events_tmp = [];
			const current_view = this.view_options_select.map(v => { return v.value });

			if (this.tasks.length !== 0 && (current_view.includes(Event_Task_Active) || current_view.includes(Event_Task_Completed))) {
				const status_ids = this._getFilterStatus();
				const tasks_data = JSON.parse(JSON.stringify(this.tasks));
				tasks_data.forEach(t => {
					if (t.date_fmt && status_ids.includes(t.status.id)) {
						const event_obj = t;
						event_obj.start_date = t.start_time.length === 0 ? moment(t.start_date, 'Do MMM YYYY').format('YYYY-MM-DD') : moment(`${t.start_date} ${t.start_time}`, 'Do MMM YYYY hh:mma' ).format('YYYY-MM-DD HH:mm');
						event_obj.end_date = t.end_time.length === 0 ? moment(t.end_date, 'Do MMM YYYY').format('YYYY-MM-DD') : moment(`${t.end_date} ${t.end_time}`, 'Do MMM YYYY hh:mma' ).format('YYYY-MM-DD HH:mm');
						event_obj['budget_left'] = this._getBudgetLeft(t);
						event_obj['type'] = Event_Task;
						events_tmp.push(event_obj);
					}
				});
			}

			if (this.timesheets.length !== 0) {
				const timesheets_data = JSON.parse(JSON.stringify(this.timesheets));
				timesheets_data.forEach(t => {
					const event_obj = t;
					event_obj.start_date = t.start ? moment(`${t.date} ${t.start}`).format('YYYY-MM-DD HH:mm') : t.date;
					event_obj.end_date = t.stop ? moment(`${t.date} ${t.stop}`).format('YYYY-MM-DD HH:mm') : t.date;
					event_obj['type'] = Event_Timesheet;
					event_obj['duration_fmt'] = this._minutesToBudget(t.duration);
					events_tmp.push(event_obj);
				});
			}

			if (this.leaves.length !== 0) {
				const leaves_data = JSON.parse(JSON.stringify(this.leaves));
				leaves_data.forEach(t => {
					const event_obj = t;
					event_obj.start_date = t.all_day ? moment(t.start_datetime, 'YYYYMMDD HH:mm:ss').format('YYYY-MM-DD') : moment(t.start_datetime, 'YYYYMMDD HH:mm:ss').format('YYYY-MM-DD HH:mm');
					event_obj.end_date = t.all_day ? moment(t.end_datetime, 'YYYYMMDD HH:mm:ss').format('YYYY-MM-DD') : moment(t.end_datetime, 'YYYYMMDD HH:mm:ss').format('YYYY-MM-DD HH:mm');
					event_obj['type'] = Event_Leave;
					event_obj['duration_fmt'] = this._minutesToBudget(t.duration);
					events_tmp.push(event_obj);
				});
			}

			if (this.items.length !== 0) {
				const items_data = JSON.parse(JSON.stringify(this.items));
				items_data.forEach(t => {
					const event_obj = t;
					event_obj.start_date = t.date;
					event_obj.end_date = t.date;
					event_obj['type'] = Event_Item;
					events_tmp.push(event_obj);
				});
			}

			if (this.holidays.length !== 0) {
				const holidays_data = JSON.parse(JSON.stringify(this.holidays));
				holidays_data.forEach(t => {
					const event_obj = t;
					event_obj.start_date = t.all_day ? moment(t.start_datetime, 'YYYYMMDD HH:mm:ss').format('YYYY-MM-DD') : moment(t.start_datetime, 'YYYYMMDD HH:mm:ss').format('YYYY-MM-DD HH:mm');
					event_obj.end_date = t.all_day ? moment(t.end_datetime, 'YYYYMMDD HH:mm:ss').format('YYYY-MM-DD') : moment(t.end_datetime, 'YYYYMMDD HH:mm:ss').format('YYYY-MM-DD HH:mm');
					event_obj['type'] = Event_Holiday;
					events_tmp.push(event_obj);
				});
			}

			if (this.other_events) {
				const events_data = JSON.parse(JSON.stringify(this.other_events));
				events_data.forEach(t => {
					const event_obj = t;
					event_obj.start_date = t.all_day ? moment(t.start_datetime, 'YYYYMMDD HH:mm:ss').format('YYYY-MM-DD') : moment(t.start_datetime, 'YYYYMMDD HH:mm:ss').format('YYYY-MM-DD HH:mm');
					event_obj.end_date = t.all_day ? moment(t.end_datetime, 'YYYYMMDD HH:mm:ss').format('YYYY-MM-DD') : moment(t.end_datetime, 'YYYYMMDD HH:mm:ss').format('YYYY-MM-DD HH:mm');
					event_obj['type'] = Event_Events;
					events_tmp.push(event_obj);
				});
			}

			return events_tmp;
		},
		cal() {
			return this.ready ? this.$refs.calendar : null
		},
		nowY() {
			return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px'
		},
		userAddressId() {
			return this.$store.state.user && this.$store.state.user.addressbook.id;
		},
		userAddressName() {
			return this.$store.state.user && this.$store.state.user.addressbook.display_name;
		},
		titleDate() {
			let day = '';
			if (this.types_select === 'month') {
				const month = moment(this.calendar_date).format('MMMM YYYY');
				day = month;
			} else if (this.types_select === 'day') {
				const date = moment(this.calendar_date).format('D MMMM YYYY');
				day = date;
			} else {
				const date_range = this._setDateRange();
				const start_year = moment(date_range.start_date).format('YYYY');
				const end_year = moment(date_range.end_date).format('YYYY');

				const start_month = moment(date_range.start_date).format('MMM');
				const end_month = moment(date_range.end_date).format('MMM');

				const start_date = moment(date_range.start_date).format('D');
				const end_date = moment(date_range.end_date).format('D');

				if (start_year !== end_year) {
					day = `${start_date} ${start_month} ${start_year} - ${end_date} ${end_month} ${end_year}`;
				} else if(start_month !== end_month) {
					day = `${start_date} ${start_month} - ${end_date} ${end_month} ${end_year}`;
				} else {
					const month_tmp = moment(date_range.end_date).format('MMMM');
					day = `${start_date} - ${end_date} ${month_tmp} ${end_year}`;
				}
			}

			return day;
		},
		completedJobPrivilege() {
			let isCompletedJobTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(JOr)) {
				isCompletedJobTmp = true;
			}
			return isCompletedJobTmp
		},
		dateTimePrivilege() {
			let isDateTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TrSc)) {
				isDateTmp = true;
			}
			return isDateTmp;
		},
		custom_weekdays() {
			let weekdays = [];

			if (this.types_select === 'custom-daily') {
				const start_index = moment(this.start_custom_weekly).weekday();
				const end_index = moment(this.end_custom_weekly).weekday();

				const weekdays_tmp = [];

				if (start_index <= end_index) {
					for (let index = start_index; index < end_index + 1; index++) {
						weekdays_tmp.push(index)
					}
				}

				if (start_index > end_index) {
					for (let index = start_index; index <= end_index + 7; index++) {
						const week_index = index - 7 >= 0 ? index - 7 : index;
						weekdays_tmp.push(week_index)						
					}
				}

				const weekend_filter = this.view_options_select.filter(o =>{ return o.value === 'weekends' });
				const days_flag = weekend_filter.length === 0 ? Workday : Weekday;
				weekdays = weekdays_tmp.filter(w => { return days_flag.includes(w) });
			}

			return weekdays;
		},
		onlyAmendOwnEventsPrivilege() {
			let isOnlyAmendOwnEvents = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(EVOwn)) {
				isOnlyAmendOwnEvents = true;
			}
			return isOnlyAmendOwnEvents;
		},
		approveLeaveEventsPrivilege() {
			let isApproveLeaveEvents = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(DAppLeave)) {
				isApproveLeaveEvents = true;
			}
			return isApproveLeaveEvents;
		},
		modifyPubHolPrivilege() {
			let isModifyPubHolPrivilege = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(DPubHol)) {
				isModifyPubHolPrivilege = true;
			}
			return isModifyPubHolPrivilege;
		}
	},
	methods: {
		updateTime () {
			setInterval(() => this.cal.updateTimes(), 60 * 1000)
		},
		getCurrentDate() {
			const date_old = this.currentDate;
			const date_new = moment().format('YYYY-MM-DD');
			if (date_old !== date_new) {
				this.calendar_date = date_new
				this.currentDate = date_new;
				this.picker = date_new;

				if (this.cal) {
					this.cal.updateTimes();
				}
			}
		},
		initBasicSetting() {
			// init weekdays type
			const weekend_filter = this.options.filter(o =>{ return o.value === 'weekends' });
			this.weekdays = weekend_filter.length === 0 ? Workday : Weekday;

			// init date range
			const date_range = this._setDateRange();
			this.start_custom_weekly = date_range.start_date;
			this.end_custom_weekly = date_range.end_date;

			// init which one be seleced to display
			if (this.display.length === 0) {
				const assigned_to_obj = {
					id: `${ALLEMPLOYEES}_${this.userAddressId}`,
					name: this.userAddressName,
					type: ALLEMPLOYEES
				};

				this.assigned_to.push(assigned_to_obj);
			}
		},
		async initSetupTime() {
			this.loading = true;

			let url = '/api/config/setup/time';
			await axios
				.get(url, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const start_time_obj = {};
						const end_time_obj = {};
						for (const [key, value] of Object.entries(data)) {
							if (key.startsWith('s')) {
								const week_key = key.split('_');
								start_time_obj[`${week_key[1]}`] = value;
							}

							if (key.startsWith('e')) {
								const week_key = key.split('_');
								end_time_obj[`${week_key[1]}`] = value;
							}
						}
					
						const work_time_monday = [ start_time_obj['monday'], end_time_obj['monday'] ];
						const work_time_tuesday = [ start_time_obj['tuesday'], end_time_obj['tuesday'] ];
						const work_time_wednesday = [ start_time_obj['wednesday'], end_time_obj['wednesday'] ];
						const work_time_thursday = [ start_time_obj['thursday'], end_time_obj['thursday'] ];
						const work_time_friday = [ start_time_obj['friday'], end_time_obj['friday'] ];
						const work_time_saturday = [ start_time_obj['saturday'], end_time_obj['saturday'] ];
						const work_time_sunday = [ start_time_obj['sunday'], end_time_obj['sunday'] ];
						const work_time = [work_time_sunday, work_time_monday, work_time_tuesday, work_time_wednesday, work_time_thursday, work_time_friday, work_time_saturday];
						this.work_time = work_time;

						const task_work_time = [work_time_monday, work_time_tuesday, work_time_wednesday, work_time_thursday, work_time_friday, work_time_saturday, work_time_sunday];
						this.task_workday = task_work_time;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async getUserTimezone() {
			const url = '/api/user/me/timezone';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.user_timezone = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getStatusses() {
			this.loading = true;
			const url = '/api/tasks/meta';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, meta, reason } = json;
					if (status == "OK") {
						this.statusses = meta.statusses;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async getJobStatusIds() {
			this.loading = true;
			const url = '/api/jobs/meta';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const statuses_arr = data.substatusses;
						const job_invalid_statusses = statuses_arr.filter(s => { return !config.job_status_group_nomal.includes(s.group) });
						this.job_invalid_status_ids = job_invalid_statusses.map(s => { return s.id });
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async getRoles() {
			const url = '/api/config/orgchart/roles';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						
						const roles = data.map(d => { return { id: `${ROLES}_${d.id}`, name: d.desc, type: ROLES } });
						this.assignItems.forEach(a => {
							if (a.id === ROLES) {
								a.children = roles;
							}
						});

						roles.forEach(r => {
							if (!this.color_calendars[`${r.id}`]) {
								const color = this._getRandomColor();
								this.color_calendars[`${r.id}`] = color;
							}
						});

					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getDepartments() {
			const url = '/api/config/orgchart/departments';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const departments = data.map(d => { return { id: `${DEPARTMENTS}_${d.id}`, name: d.desc, type: DEPARTMENTS } });
						this.assignItems.forEach(a => {
							if (a.id === DEPARTMENTS) {
								a.children = departments;
							}
						});

						departments.forEach(d => {
							if (!this.color_calendars[`${d.id}`]) {
								const color = this._getRandomColor();
								this.color_calendars[`${d.id}`] = color;
							}
						});
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getAllEmployees() {
			let url = '/api/addressbook';
			const params = [];

			// 3 = "Employees", 12 = 'Freelancers', from 'api/addressbook/meta'
			params.push("abook_types=" + encodeURIComponent("3, 12")); 
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const unique = [];
						const obj_tmp = {};
						data.forEach(d => {
							if (!obj_tmp[d.id]) {
								unique.push(d);
								obj_tmp[d.id] = true;
							}
						});

						const employees = [];
						unique.forEach(e => {
							let display_name = '';
							if (e.display_name.includes(',')) {
								const name_arr = e.display_name.split(',');
								if (name_arr[1].includes('(')) {
									const name_tmp = name_arr[1];
									const index = name_tmp.indexOf('(');
									display_name = `${name_tmp.substring(0, index-1)} ${name_arr[0]} ${name_tmp.substring(index, name_tmp.length)}`;
								} else {
									display_name = `${name_arr[1].trim()} ${name_arr[0]}`;
								}

							} else {
								display_name = e.display_name;
							}

							const obj = {
								id: `${ALLEMPLOYEES}_${e.id}`,
								name: display_name,
								type: ALLEMPLOYEES
							};
							employees.push(obj);
						});

						this.assignItems.forEach(a => {
							if (a.id === ALLEMPLOYEES) {
								a.children = employees;
							}
						});

						employees.forEach(e => {
							if (!this.color_calendars[`${e.id}`]) {
								const color = this._getRandomColor();
								this.color_calendars[`${e.id}`] = color;
							}
						});
						this.color_calendars[`${ALLEMPLOYEES}_${this.userAddressId}`] = CurrentUserColor;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async initEevent() {
			this.tasks = [];
			this.timesheets = [];
			await this.getWorkdays();

			let current_view = this.view_options_select.map(v => { return v.value });
			const date_range = this._setDateRange();

			if (this.assigned_to.length <= 1) {
				let id = 0;
				let element = {};
				if (this.assigned_to.length === 0) {
					id = this.userAddressId;
					element['type'] = 2;
				} else {
					element = this.assigned_to[0];
					const id_arr = element.id.split('_');
					id = id_arr[id_arr.length -1];
				}

				if (Number(id) === this.userAddressId) {
					const params_task = this._setTaskParams(NotSuggestedMode, date_range.start_date, date_range.end_date, [id], element.type);
					await this._getTasks(params_task, false);

					const params_event = this._setEventParams(this.userAddressId, date_range.start_date, date_range.end_date);
					await this._getEvents(params_event, current_view);

					/** build capacity bar(Leave, Events. Timesheets, Public Holiday) */
					const capacity_by_date = {};

					const params = [];
					params.push('from_date='+ date_range.start_date);
					params.push('to_date='+ date_range.end_date);
					params.push('emp_ids='+ `${this.userAddressId}`);

					await this._getCapacity(params)
						.then(data => {
							for (let index = 0; index < data.length; index++) {
								const one_day = data[index];

								/** get un-workday of company */
								const un_work_company = [];
								this.work_time.forEach((work, index) => {
									if (work[0].length === 0 && work[1].length === 0) {
										un_work_company.push(index)
									}
								});

								if (!un_work_company.includes(moment(one_day.date).weekday())) {
									const timesheet_per_day = (one_day.actual_hrs * 60).toFixed(0);
									const available_per_day = (one_day.available_hours * 60).toFixed(0);

									capacity_by_date[`${one_day.date}`] = {
										holiday: 0,
										leave: 0,
										event: 0,
										timesheet: Number(timesheet_per_day),
										task: 0,
										available:  Number(available_per_day)
									};
								}
							}
						})
						.catch((reason) => {
							this.error_msg = reason;
						});

					this.progress_by_date = this._setProcessParams(this.holidays, this.leaves, this.other_events, this.tasks, capacity_by_date);

				} else {
					this.progress_by_date = null;
					this.view_options_select = this.view_options_select.filter(v => { return v.value !== Event_Timesheet && v.value !== Event_Leave && v.value !== Event_Item && v.value !== Event_Holiday });

					current_view = this.view_options_select.map(v => { return v.value });
				}
			}

			if (this.assigned_to.length > 1) {
				this.progress_by_date = null;
				this.view_options_select = this.view_options_select.filter(v => { return v.value !== Event_Timesheet && v.value !== Event_Leave && v.value !== Event_Item && v.value !== Event_Holiday });

				current_view = this.view_options_select.map(v => { return v.value });
			}

			if (current_view.includes(Event_Task_Active) || current_view.includes(Event_Task_Completed)) {
				for (let index = 0; index < this.assigned_to.length; index++) {
					const element = this.assigned_to[index];
					const id_arr = element.id.split('_');
					const id = id_arr[id_arr.length -1];
					const type = element.type;

					const params_task = this._setTaskParams(NotSuggestedMode, date_range.start_date, date_range.end_date, id, type);
					await this._getTasks(params_task, true);
				}
			} else {
				this.tasks = [];
			}

			if (current_view.includes(Event_Timesheet)) {
				const params_timesheet = this._setTimesheetParams(this.userAddressId, date_range.start_date, date_range.end_date);
				await this._getTimesheets(params_timesheet);
			} else {
				this.timesheets = [];
			}

			if (current_view.includes(Event_Item)) {
				const params_timesheet = this._setTimesheetParams(this.userAddressId, date_range.start_date, date_range.end_date);
				await this._getItems(params_timesheet);
			} else {
				this.items = [];
			}

			if (current_view.includes(Event_Events) || current_view.includes(Event_Holiday) || current_view.includes(Event_Leave)) {
				const params_event = this._setEventParams(this.userAddressId, date_range.start_date, date_range.end_date);
				await this._getEvents(params_event, current_view);
			}

			if (this.worklist_open_id !== 0) {
				const item = this.worklists.filter(w => { return w.id === this.worklist_open_id });
				this._getTasklist(this.worklist_open_id, item[0].settings);
			}
			this.finish_timesheet_flag = false;
		},
		getOptionDisable(option_value) {
			let disable  = false;

			if (option_value !== Event_Task_Active && option_value !== Event_Task_Completed && option_value !== Event_Weekends) {
				if (this.assigned_to.length === 1) {
					const id = (this.assigned_to[0].id.split('_'))[1];

					if (Number(id) !== this.userAddressId) {
						disable = true;
					}
				}

				if (this.assigned_to.length > 1) {
					disable = true;
				}
			}

			return disable;
		},
		getCurrentTime () {
			return this.cal ? this.cal.times.now.hour * 60 + this.cal.times.now.minute : 0
		},
		scrollToTime () {
			const time = this.getCurrentTime()
			const first = Math.max(0, time - (time % 30) - 30)

			this.cal.scrollToTime(first)
		},
		getWorklist() {
			this.loading_worklist = true;

			const params = [];
			params.push("class=" + encodeURIComponent(TASKLIST_CLASS));
			params.push("include_shared=false");
			params.push("include_hidden=true");

			let url = "/api/worklists";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						data.forEach(d => {
							d['tasks'] = [];
							d['tasksOrigin'] = [];
						});
						this.worklists = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				}).finally(() => {
					this.loading_worklist = false;
				});
		},
		async getWorkdays() {
			this.workdays = [];
			const date_range = this._setDateRange();
			const params = [];
			const from_date = moment(date_range.start_date).subtract(7, 'days').format('YYYY-MM-DD');
			const to_date = moment(date_range.end_date).add(7, 'days').format('YYYY-MM-DD');

			params.push('from_date='+ from_date);
			params.push('to_date='+ to_date);
			params.push('emp_ids='+ `${this.userAddressId}`);
			await this._getCapacity(params)
				.then(data => {
					for (let index = 0; index < data.length; index++) {
						const one_day = data[index];

						if (one_day.available_hours !== 0) {
							this.workdays.push(one_day.date);
						}
					}
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
		},
		prev() {
			if (this.types_select === 'custom-weekly') {
				const start_custom_weekly_tmp = this.start_custom_weekly;
				const start_custom_weekly = moment(start_custom_weekly_tmp).subtract(2, 'weeks').format('YYYY-MM-DD');
				const end_custom_weekly = moment(start_custom_weekly_tmp).subtract(this.weekdays.length === Workday.length ? 3:1, 'days').format('YYYY-MM-DD');

				this.calendar_date = moment(start_custom_weekly).weekday(3).format('YYYY-MM-DD');
				this.picker = this.calendar_date;
				this.start_custom_weekly = start_custom_weekly;
				this.end_custom_weekly = end_custom_weekly;
				this.initEevent();

			} else if(this.types_select === 'custom-daily') {
				const weekend_filter = this.view_options_select.filter(o =>{ return o.value === 'weekends' });

				if (weekend_filter.length !== 0) {
					const mid_date = moment(this.calendar_date).subtract(3, 'days').format('YYYY-MM-DD');
					const start_custom_weekly = moment(mid_date).subtract(1, 'days').format('YYYY-MM-DD');
					const end_custom_weekly = moment(mid_date).add(1, 'days').format('YYYY-MM-DD');

					this.calendar_date = mid_date;
					this.picker = this.calendar_date;
					this.start_custom_weekly = start_custom_weekly;
					this.end_custom_weekly = end_custom_weekly;
				} else {
					const mid_date_tmp = moment(this.calendar_date).subtract(3, 'days').format('YYYY-MM-DD');
					const mid_date = this._subtractNoWeekend(mid_date_tmp);

					const start_date_tmp = moment(mid_date).subtract(1, 'days').format('YYYY-MM-DD');
					const start_custom_weekly = this._subtractNoWeekend(start_date_tmp);

					const end_date_tmp = moment(mid_date).add(1, 'days').format('YYYY-MM-DD');
					const end_custom_weekly = this._addNoWeekend(end_date_tmp);

					this.calendar_date = mid_date;
					this.picker = this.calendar_date;
					this.start_custom_weekly = start_custom_weekly;
					this.end_custom_weekly = end_custom_weekly;
				}

				this.initEevent();

			} else {
				this.$refs.calendar.prev();
				this.picker = this.calendar_date;
				this.initEevent();
			}
		},
		next() {
			if (this.types_select === 'custom-weekly') {
				const start_custom_weekly = moment(this.end_custom_weekly).add(this.weekdays.length === Workday.length ? 3:1, 'days').format('YYYY-MM-DD');
				const end_custom_weekly = moment(this.end_custom_weekly).add(2, 'weeks').format('YYYY-MM-DD');

				this.calendar_date = moment(start_custom_weekly).weekday(3).format('YYYY-MM-DD');
				this.picker = this.calendar_date;
				this.start_custom_weekly = start_custom_weekly;
				this.end_custom_weekly = end_custom_weekly;
				this.initEevent();

			} else if (this.types_select === 'custom-daily') {
				const weekend_filter = this.view_options_select.filter(o =>{ return o.value === 'weekends' });

				if (weekend_filter.length !== 0) {
					const mid_date =  moment(this.calendar_date).add(3, 'days').format('YYYY-MM-DD');
					const start_custom_weekly = moment(mid_date).subtract(1, 'days').format('YYYY-MM-DD');
					const end_custom_weekly = moment(mid_date).add(1, 'days').format('YYYY-MM-DD');

					this.calendar_date = mid_date;
					this.picker = this.calendar_date;
					this.start_custom_weekly = start_custom_weekly;
					this.end_custom_weekly = end_custom_weekly;
				} else {
					const mid_date_tmp =  moment(this.calendar_date).add(3, 'days').format('YYYY-MM-DD');
					const mid_date = this._addNoWeekend(mid_date_tmp);

					const start_date_tmp = moment(mid_date).subtract(1, 'days').format('YYYY-MM-DD');
					const start_custom_weekly = this._subtractNoWeekend(start_date_tmp);

					const end_date_tmp = moment(mid_date).add(1, 'days').format('YYYY-MM-DD');
					const end_custom_weekly = this._addNoWeekend(end_date_tmp);

					this.calendar_date = mid_date;
					this.picker = this.calendar_date;
					this.start_custom_weekly = start_custom_weekly;
					this.end_custom_weekly = end_custom_weekly;
				}
				
				this.initEevent();

			} else {
				this.$refs.calendar.next();
				this.picker = this.calendar_date;
				this.initEevent();
			}
		},
		onChangeToToday() {
			this.calendar_date = moment().format('YYYY-MM-DD');
			this.picker = this.calendar_date;

			const date_range = this._setDateRange();
			this.start_custom_weekly = date_range.start_date;
			this.end_custom_weekly = date_range.end_date;
			
			this.initEevent();
		},
		intervalStyle (interval) {
			if (this.work_time.length === 0) return;

			const week_day = moment(interval.date).day();
			const start_time = (this.work_time[week_day])[0];
			const end_time = (this.work_time[week_day])[1];

			const start_time_moment = moment(start_time, 'HH:mm');
			const end_time_moment = moment(end_time, 'HH:mm');
			const isWorkTime = moment(interval.time, 'HH:mm').isBetween(start_time_moment, end_time_moment, 'hour');

			if (!isWorkTime && interval.time !== start_time) {
				return { background: '#FAFAFA' };
			}
		},
		isExtendBottom(item) {
			let isAvalible = false;
			if (item.type === this.event_task && item.status.type !== this.status_completed_type && this.dateTimePrivilege) {
				isAvalible = true;
			}
			if (item.type === this.event_timesheet && this.privileges.includes(TS)) {
				isAvalible = true;
			}
			if (item.type === this.event_leave && !item.leave_approved) {
				isAvalible = true;
			}
			return isAvalible;
		},
		getTaskClass(item) {
			if (item.type !== this.event_task) return '';

			let drag_str = '';

			if (item.status.type !== this.status_completed_type && this.dateTimePrivilege && item.job_valid) {
				if (this.mousedownFired) {
					drag_str = 'drag-able';
				}
			} else {
				drag_str = 'drag-disable';
			}

			return drag_str;
		},
		getTaskStyle(item) {
			if (item.type !== this.event_task) return '';

			const text_color = `color: ${this.formatColor(item.color)}`;
			const past_str = this._isPastTask(item.end_date) ? 'opacity: 0.5':'';
			const event_str = this.dragEvent || this.createEvent ? 'opacity: 0.7':'';
			const justify_str = this.$vuetify.breakpoint.smAndDown || this.types_select === 'month' ? 'justify-content: flex-start':''

			const style_str = `${text_color}; ${past_str}; ${event_str};  ${justify_str}`;
			return style_str;
		},
		getLeaveClass(item) {
			if (item.type !== Event_Leave && item.type !== Event_Holiday) return '';

			let drag_str = '';
			if (item.leave_paid) {
				drag_str = 'drag-disable';

			} else if (item.leave_approved) {
				drag_str = 'drag-disable';
			} else {
				if (item.type === Event_Leave) {
					if (item.employee_id === this.userAddressId) {
						drag_str = 'leave-item-container-pending drag-able';
					} else {
						if (this.onlyAmendOwnEventsPrivilege) {
							drag_str = 'leave-item-container-pending drag-disable';
						} else {
							if (this.approveLeaveEventsPrivilege) {
								drag_str = 'leave-item-container-pending drag-able';
							} else {
								drag_str = 'leave-item-container-pending drag-disable';
							}
						}
					}
				}

				if (item.type === Event_Holiday) {
					if (this.modifyPubHolPrivilege) {
						drag_str = 'leave-item-container-pending drag-able';
					} else {
						drag_str = 'leave-item-container-pending drag-disable';
					}
				}
			}

			return drag_str;
		},
		/** dragging */
		startDrag ({ event, timed }) {
			/** 
			 * Task
			 * from day to day, or from time to time, or from day to time
			 * show the dialog when drag to un-workday
			 */
			/** 
			 * Timesheet
			 * from day to day, or from time to time, or from day to time
			 * be able to drag to any day(workday and un-workday)
			 */
			/** 
			 * Event
			 * from day to day, or from time to time
			 * be able to drag to any day(workday and un-workday)
			 */
			/** 
			 * Leave
			 * from day to day, or from time to time, or from day to time
			 * be able to drag to any day(workday and un-workday)
			 */
			/** 
			 * Public holiday
			 * from day to day, or from time to time
			 * be able to drag to any day(workday and un-workday)
			 */
			/** 
			 * Item
			 * not able to drag
			 */

			if (!event.job_valid || this.finish_timesheet_flag) return;

			/** timed=true => not whole day event */
			if (event && timed) {
				if (event.type === Event_Task && (event.status.type === this.status_completed_type || !this.dateTimePrivilege)) {
					this.dragEvent = null;
				} else if (event.type === Event_Leave && !this._isAbleDragLeave(event)) {
					this.dragEvent = null;
				} else if (event.type === Event_Holiday && !this._isAbleDragHoliday(event)) {
					this.dragEvent = null;
				} else if (event.type === Event_Timesheet && !this.privileges.includes(TS)) {
					this.dragEvent = null;
				} else if (event.type === Event_Item) {
					this.dragEvent = null;
				} else {
					this.dragEvent = event;
				}

				this.dragTime = null;
				this.extendOriginal = null;
			}

			/** timed=false => whole day event */
			if (event && !timed) {
				if (event.type === Event_Task && (event.status.type === this.status_completed_type || !this.dateTimePrivilege)) {
					this.dragEvent = null;
				} else if (event.type === Event_Leave && !this._isAbleDragLeave(event)) {
					this.dragEvent = null;
				} else if (event.type === Event_Holiday && !this._isAbleDragHoliday(event)) {
					this.dragEvent = null;
				} else if (event.type === Event_Timesheet && !this.privileges.includes(TS)) {
					this.dragEvent = null;
				} else if (event.type === Event_Item) {
					this.dragEvent = null;
				} else {
					this.dragEvent = event;
				}

				this.dragDay = null;
			}
		},
		startTime (tms) {
			if (this.dragEvent && this.dragTime === null && !this.finish_timesheet_flag) {
				/** part time event(from time to time) */
				const mouse = this.toTime(tms);
				const start_tmp = this.dragEvent.start_date;
				const start = new Date(start_tmp).getTime();
				this.dragTime = mouse - start;
			} else {
				// todo, 
				// if have time,to this; if no time, close this
				// drag and has start time and end time
				this.$emit('create', []);
			}
		},
		startDay(tms) {
			if (this.dragEvent && this.dragDay === null && !this.finish_timesheet_flag) {
				/** whole day event(from day to day, or day to time) */
				this.dragDay = tms.date;
			}
		},
		mouseMove (tms) {
			const mouse = this.toTime(tms);

			if (this.dragEvent && this.dragTime !== null && !this.finish_timesheet_flag) {
				/** from time to time */
				const start_date_tmp = this.dragEvent.start_date;
				const end_date_tmp = this.dragEvent.end_date;

				const start = new Date(start_date_tmp).getTime();
				const end = new Date(end_date_tmp).getTime();

				const duration = end - start;
				const newStartTime = mouse - this.dragTime;

				const newStart = this.roundTime(newStartTime);
				const newEnd = newStart + duration;

				if (this.dragEvent.type === Event_Task) {
					const start_date = moment(newStart).format('Do MMM YYYY');
					const end_date = moment(newEnd).format('Do MMM YYYY');
					const start_time = moment(newStart).format('hh:mma');
					const end_time = moment(newEnd).format('hh:mma');

					const date_tmp = moment(newStart).format('YYYY-MM-DD');
					const event_date_tmp = moment(this.dragEvent.start_date).format('YYYY-MM-DD');

					const diff_start = moment(this.dragEvent.start_time, 'hh:mma');
					const diff_end = moment(start_time, 'hh:mma');
					const diff = diff_start.diff(diff_end, 'm');

					if (date_tmp !== event_date_tmp || (start_time !== this.dragEvent.start_time && Math.abs(diff) > 15)) {
						this.mousedownFired = true;
						
						this.tasks.forEach(t => {
							if (t.id === this.dragEvent.id) {
								t.start_date = start_date;
								t.end_date = end_date;
								t.start_time = start_time;
								t.end_time = end_time;
							}
						});
					}
					
				}
				if (this.dragEvent.type === Event_Timesheet) {
					const date = moment(newStart).format('YYYY-MM-DD');
					const start = moment(newStart).format('HH:mm:ss');
					const stop = moment(newEnd).format('HH:mm:ss');
					
					const diff_start = moment(this.dragEvent.start, 'HH:mm:ss');
					const diff_end = moment(start, 'HH:mm:ss');
					const diff = diff_start.diff(diff_end, 'm');

					if (date !== this.dragEvent.date || (start !== this.dragEvent.start && Math.abs(diff) > 15)) {
						this.mousedownFired = true;
						
						this.timesheets.forEach(t => {
							if (t.id === this.dragEvent.id) {
								t.date = date;
								t.start = start;
								t.stop = stop;
							}
						});
					}
				}
				if (this.dragEvent.type === Event_Leave) {
					const start_date = moment(newStart).format('YYYY-MM-DD HH:mm:ss');
					const end_date = moment(newEnd).format('YYYY-MM-DD HH:mm:ss');

					const date_tmp = moment(newStart).format('YYYY-MM-DD');
					const event_date_tmp = moment(this.dragEvent.start_date).format('YYYY-MM-DD');
					const time_tmp = moment(newStart).format('HH:mm');
					const event_time_tmp = moment(this.dragEvent.start_date).format('HH:mm');

					const diff_start = moment(event_time_tmp, 'HH:mm');
					const diff_end = moment(time_tmp, 'HH:mm');
					const diff = diff_start.diff(diff_end, 'm');

					if (date_tmp !== event_date_tmp || (time_tmp !== event_time_tmp && Math.abs(diff) > 15)) {
						this.mousedownFired = true;

						const start = moment(newStart);
						const end = moment(newEnd);
						const duration = end.diff(start, 'minutes');

						this.leaves.forEach(t => {
							if (t.id === this.dragEvent.id) {
								t.all_day = false;
								t.duration = duration;
								t.start_datetime = start_date;
								t.end_datetime = end_date;
							}
						});
					}					
				}
				if (this.dragEvent.type === Event_Events) {
					const start_date = moment(newStart).format('YYYYMMDD HH:mm:ss');
					const end_date = moment(newEnd).format('YYYYMMDD HH:mm:ss');

					const date_tmp = moment(newStart).format('YYYY-MM-DD');
					const event_date_tmp = moment(this.dragEvent.start_datetime, 'YYYYMMDD HH:mm:ss').format('YYYY-MM-DD');
					const time_tmp = moment(newStart).format('HH:mm:ss');
					const event_time_tmp = moment(this.dragEvent.start_date, 'YYYYMMDD HH:mm:ss').format('HH:mm:ss');

					if (date_tmp !== event_date_tmp || time_tmp !== event_time_tmp) {
						this.mousedownFired = true;

						this.other_events.forEach(t => {
							if (t.id === this.dragEvent.id && t.iteration === this.dragEvent.iteration) {
								t.all_day = false;
								t.start_datetime = start_date;
								t.end_datetime = end_date;
							}
						});
					}	
				}
				if (this.dragEvent.type === Event_Holiday) {
					const start_date = moment(newStart).format('YYYYMMDD HH:mm:ss');
					const end_date = moment(newEnd).format('YYYYMMDD HH:mm:ss');

					const date_tmp = moment(newStart).format('YYYY-MM-DD');
					const event_date_tmp = moment(this.dragEvent.start_datetime, 'YYYYMMDD HH:mm:ss').format('YYYY-MM-DD');
					const time_tmp = moment(newStart).format('HH:mm:ss');
					const event_time_tmp = moment(this.dragEvent.start_date, 'YYYYMMDD HH:mm:ss').format('HH:mm:ss');

					if (date_tmp !== event_date_tmp || time_tmp !== event_time_tmp) {
						this.mousedownFired = true;

						this.holidays.forEach(t => {
							if (t.id === this.dragEvent.id && t.iteration === this.dragEvent.iteration) {
								t.all_day = false;
								t.start_datetime = start_date;
								t.end_datetime = end_date;
							}
						});
					}	
				}

			} else if (this.dragEvent && this.dragDay !== null && !this.finish_timesheet_flag) {
				/** from day to time */
				this.mousedownFired = true;

				const newStartTime = mouse;
				const newStart = this.roundTime(newStartTime);

				if (this.dragEvent.type === Event_Task && this.dragEvent.task_days === 1) {
					const start_date = moment(newStart).format('Do MMM YYYY');
					const start_time = moment(newStart).format('HH:mm:ss');
					const end_date = moment(newStart).add(this.dragEvent.budget, 'm').format('Do MMM YYYY');
					const end_time = moment(newStart).add(this.dragEvent.budget, 'm').format('HH:mm:ss');

					this.tasks.forEach(t => {
						if (t.id === this.dragEvent.id) {
							t.start_date = start_date;
							t.end_date = end_date;
							t.start_time = start_time;
							t.end_time = end_time;
						}
					});
				}
				if (this.dragEvent.type === Event_Timesheet) {
					const date = moment(newStart).format('YYYY-MM-DD');
					const start = moment(newStart).format('HH:mm:ss');

					this.timesheets.forEach(t => {
						if (t.id === this.dragEvent.id) {
							const stop = moment(newStart).add(t.duration, 'minutes').format('HH:mm:ss');
							t.date = date;
							t.start = start;
							t.stop = stop;
						}
					});
				}
				if (this.dragEvent.type === Event_Leave) {
					const start_date = moment(newStart).format('YYYY-MM-DD HH:mm:ss');
					const end_date = moment(newStart).add(1, 'hours').format('YYYY-MM-DD HH:mm:ss');
					const duration = 60;

					this.leaves.forEach(t => {
						if (t.id === this.dragEvent.id) {
							t.all_day = false;
							t.duration = duration;
							t.start_datetime = start_date;
							t.end_datetime = end_date;
						}
					});
				}
			} else if (this.createEvent && this.createStart !== null && !this.finish_timesheet_flag) {
				this.mousedownFired = true;

				const mouseRounded = this.roundTime(mouse, false);
				const min = Math.min(mouseRounded, this.createStart);
				const max = Math.max(mouseRounded, this.createStart);

				if (this.createEvent.type === Event_Task) {
					const start_date = moment(min).format('Do MMM YYYY');
					const end_date = moment(max).format('Do MMM YYYY');
					const start_time = moment(min).format('hh:mma');
					const end_time = moment(max).format('hh:mma');

					this.tasks.forEach(t => {
						if (t.id === this.createEvent.id) {
							t.start_date = start_date;
							t.end_date = end_date;
							t.start_time = start_time;
							t.end_time = end_time;
						}
					});
				} 
				if (this.createEvent.type === Event_Timesheet) {
					const date = moment(min).format('YYYY-MM-DD');
					const start = moment(min).format('HH:mm:ss');
					const stop = moment(max).format('HH:mm:ss');

					this.timesheets.forEach(t => {
						if (t.id === this.createEvent.id) {
							t.date = date;
							t.start = start;
							t.stop = stop;
						}
					});
				}
				if (this.createEvent.type === Event_Leave) {
					const start_date = moment(min).format('YYYY-MM-DD HH:mm:ss');
					const end_date = moment(max).format('YYYY-MM-DD HH:mm:ss');

					const start = moment(min);
					const end = moment(max);
					const duration = end.diff(start, 'minutes');
					this.leaves.forEach(t => {
						if (t.id === this.createEvent.id) {
							t.all_day = false;
							t.duration = duration;
							t.start_datetime = start_date;
							t.end_datetime = end_date;
						}
					});
				}
			}
		},
		mouseMoveDay({date}) {
			/** from day to day */
			if (this.dragEvent && this.dragDay !== null && this.dragDay !== date && !this.finish_timesheet_flag) {
				this.mousedownFired = true;

				if (this.dragEvent.type === Event_Task) {
					this.tasks.forEach(t => {
						if (t.id === this.dragEvent.id) {
							const start_moment = moment(t.start_date, 'Do MMM YYYY');
							const end_moment = moment(t.end_date, 'Do MMM YYYY');
							const days = end_moment.diff(start_moment, 'days');

							const end_work = moment(date).add(days, 'd').format('YYYY-MM-DD');
							const end_format = this._isWorkDay(`${end_work}`, this.workdays);
							const start = moment(date).format('Do MMM YYYY');
							const end = moment(end_format).format('Do MMM YYYY');

							t.start_date = start;
							t.end_date = end;
						}
					});
				}
				if (this.dragEvent.type === Event_Timesheet) {
					const date_tmp = moment(date).format('YYYY-MM-DD');

					this.timesheets.forEach(t => {
						if (t.id === this.dragEvent.id) {
							t.date = date_tmp;
						}
					});
				}
				if (this.dragEvent.type === Event_Leave) {
					this.leaves.forEach(t => {
						if (t.id === this.dragEvent.id) {
							const start_origin = moment(t.start_datetime, 'YYYYMMDD HH:mm:ss');
							const end_origin = moment(t.end_datetime, 'YYYYMMDD HH:mm:ss');
							const diff = end_origin.diff(start_origin, 'days');
							
							if (t.all_day) {
								const start = moment(date).format('YYYY-MM-DD HH:mm:ss');
								const end = moment(date).add(diff, 'd').format('YYYY-MM-DD HH:mm:ss');
								t.start_datetime = start;
								t.end_datetime = end;
							} else {
								const start = moment(date).format('YYYY-MM-DD');
								const end = moment(date).add(diff, 'd').format('YYYY-MM-DD');

								const start_time = moment(start_origin).format('HH:mm:ss');
								const end_time = moment(end_origin).format('HH:mm:ss');

								t.start_datetime = `${start} ${start_time}`;
								t.end_datetime = `${end} ${end_time}`;
							}
						}
					});
				}
				if (this.dragEvent.type === Event_Events) {
					this.other_events.forEach(t => {
						if (t.id === this.dragEvent.id && t.iteration === this.dragEvent.iteration) {
							if (!t.all_day) {
								const start_origin = moment(t.start_date);
								const end_origin = moment(t.end_date);
								const diff = end_origin.diff(start_origin, 'days');

								const start_day = moment(date).format('YYYYMMDD');
								const start_time = start_origin.format('HH:mm:ss');

								const end_day = moment(date).add(diff, 'd').format('YYYY-MM-DD');
								const end_time = end_origin.format('HH:mm:ss');

								t.start_datetime = moment(`${start_day} ${start_time}`, 'YYYYMMDD HH:mm:ss').format('YYYYMMDD HH:mm:ss');
								t.end_datetime = moment(`${end_day} ${end_time}`, 'YYYYMMDD HH:mm:ss').format('YYYYMMDD HH:mm:ss');
							} else {
								const start_origin = moment(t.start_date);
								const end_origin = moment(t.end_date);
								const diff = end_origin.diff(start_origin, 'days');

								const start = moment(date).format('YYYYMMDD HH:mm:ss');
								const end = moment(date).add(diff, 'd').format('YYYYMMDD HH:mm:ss');

								t.start_datetime = start;
								t.end_datetime = end;
							}
						}
					});
				}
				if (this.dragEvent.type === Event_Holiday) {
					this.holidays.forEach(t => {
						if (t.id === this.dragEvent.id && t.iteration === this.dragEvent.iteration) {
							const start_origin = moment(t.start_date);
							const end_origin = moment(t.end_date);
							const diff = end_origin.diff(start_origin, 'days');

							if (!t.all_day) {
								const start_day = moment(date).format('YYYYMMDD');
								const start_time = start_origin.format('HH:mm:ss');

								const end_day = moment(date).add(diff, 'd').format('YYYYMMDD');
								const end_time = end_origin.format('HH:mm:ss');

								t.start_datetime = moment(`${start_day} ${start_time}`, 'YYYYMMDD HH:mm:ss').format('YYYYMMDD HH:mm:ss');
								t.end_datetime = moment(`${end_day} ${end_time}`, 'YYYYMMDD HH:mm:ss').format('YYYYMMDD HH:mm:ss');
							} else {
								const start = moment(date).format('YYYYMMDD HH:mm:ss');
								const end = moment(date).add(diff, 'd').format('YYYYMMDD HH:mm:ss');

								t.start_datetime = start;
								t.end_datetime = end;
							}
						}
					});
				}
				/** keep the same behavior as Omins */
				// if (this.dragEvent.type === Event_Item) {
				// 	const date_tmp = moment(date).format('YYYY-MM-DD');

				// 	this.items.forEach(t => {
				// 		if (t.id === this.dragEvent.id) {
				// 			t.date = date_tmp;
				// 		}
				// 	});
				// }
			}
		},
		endDrag () {
			if (this.mousedownFired) {
				if (this.dragEvent) {
					if (this.dragEvent.type === Event_Task) {
						const drag_task = this.tasks.filter(t => { return t.id === this.dragEvent.id });
						if (drag_task[0].task_days <= 1) {
							const drag_date = moment(drag_task[0].start_date, 'Do MMM YYYY').format('YYYY-MM-DD');
							if (!this.workdays.includes(drag_date)) {
								const end_format = this._isWorkDay(`${drag_date}`, this.workdays);
								this.drag_msg = `${moment(drag_date).format('Do MMM YYYY')} ${Drag_MSG} ${moment(end_format).format('Do MMM YYYY')}`

								const darg_obj = drag_task[0];
								darg_obj['start_date'] = moment(end_format).format('Do MMM YYYY');

								const end_date = moment(end_format).format('Do MMM YYYY');
								darg_obj['end_date'] = end_date;

								this.drag_event = darg_obj;
								this.drag_visible = true;
							} else {
								this._updateTaskTime(drag_task[0]);
							}	
						}						
					}
					if (this.dragEvent.type === Event_Timesheet) {
						const drag_timesheet = this.timesheets.filter(t => { return t.id === this.dragEvent.id });
						this._updateTimesheet(drag_timesheet[0]);
					}
					if (this.dragEvent.type === Event_Leave) {
						const drag_leave = this.leaves.filter(t => { return t.id === this.dragEvent.id });
						this._updateEvent(drag_leave[0]);
					}
					if (this.dragEvent.type === Event_Events) {
						const drag_event = this.other_events.filter(t => { return t.id === this.dragEvent.id && t.iteration === this.dragEvent.iteration });
						this._updateEvent(drag_event[0]);
					}
					if (this.dragEvent.type === Event_Holiday) {
						const drag_holiday = this.holidays.filter(t => { return t.id === this.dragEvent.id && t.iteration === this.dragEvent.iteration });
						if (!drag_holiday[0].all_day) {
							this._updateEvent(drag_holiday[0]);
						}
					}
				}
				if (this.createEvent) {
					if (this.createEvent.type === Event_Task) {
						const drag_task = this.tasks.filter(t => { return t.id === this.createEvent.id });
						this._updateTaskTime(drag_task[0]);
					}
					if (this.createEvent.type === Event_Timesheet) {
						const drag_timesheet = this.timesheets.filter(t => { return t.id === this.createEvent.id });
						this._updateTimesheet(drag_timesheet[0]);
					}
					if (this.createEvent.type === Event_Leave) {
						const drag_leave = this.leaves.filter(t => { return t.id === this.createEvent.id });
						this._updateEvent(drag_leave[0]);
					}
					if (this.createEvent.type === Event_Events) {
						const drag_event = this.other_events.filter(t => { return t.id === this.dragEvent.id && t.iteration === this.dragEvent.iteration });
						this._updateEvent(drag_event[0]);
					}
				}
			}

			this.dragTime = null;
			this.dragDay = null;
			this.dragEvent = null;
			this.createEvent = null;
			this.createStart = null;
			this.extendOriginal = null;
			this.mousedownFired = false;
		},
		endDragDay() {
			if (this.mousedownFired) {
				if (this.dragEvent) {
					if (this.dragEvent.type === Event_Task) {
						const drag_task = this.tasks.filter(t => { return t.id === this.dragEvent.id });

						const drag_date = moment(drag_task[0].start_date, 'Do MMM YYYY').format('YYYY-MM-DD');
						if (!this.workdays.includes(drag_date)) {
							const end_format = this._isWorkDay(`${drag_date}`, this.workdays);
							this.drag_msg = `${moment(drag_date).format('Do MMM YYYY')} ${Drag_MSG} ${moment(end_format).format('Do MMM YYYY')}`
							
							const darg_obj = drag_task[0];
							const start_date = moment(end_format).format('Do MMM YYYY');
							darg_obj['start_date'] = start_date;

							const end_date = moment(start_date, 'Do MMM YYYY').add(darg_obj.task_days, 'd').format('Do MMM YYYY');
							darg_obj['end_date'] = end_date;

							this.drag_event = darg_obj;
							this.drag_visible = true;
						} else {
							if (drag_task[0].start_time.length === 0 && drag_task[0].end_time.length === 0) {
								this._updateTaskDate(drag_task[0]);
							} else {
								this._updateTaskTime(drag_task[0]);
							}
						}						
					}
					if (this.dragEvent.type === Event_Timesheet) {
						const drag_timesheet = this.timesheets.filter(t => { return t.id === this.dragEvent.id });
						this._updateTimesheet(drag_timesheet[0]);
					}
					if (this.dragEvent.type === Event_Leave) {
						const drag_leave = this.leaves.filter(t => { return t.id === this.dragEvent.id });
						this._updateEvent(drag_leave[0]);
					}
					if (this.dragEvent.type === Event_Events) {
						const drag_event = this.other_events.filter(t => { return t.id === this.dragEvent.id && t.iteration === this.dragEvent.iteration });
						this._updateEvent(drag_event[0]);
					}
					if (this.dragEvent.type === Event_Holiday) {
						const drag_holiday = this.holidays.filter(t => { return t.id === this.dragEvent.id && t.iteration === this.dragEvent.iteration });
						this._updateEvent(drag_holiday[0]);
					}

					// keep the same behavior as Omins
					// if (this.dragEvent.type === Event_Item) {
					// 	const drag_item = this.items.filter(t => { return t.id === this.dragEvent.id });
					// 	this._updateItem(drag_item[0]);
					// }
				}
			}

			this.dragTime = null;
			this.dragDay = null;
			this.dragEvent = null;
			this.createEvent = null;
			this.createStart = null;
			this.extendOriginal = null;
			this.mousedownFired = false;
		},
		onTaskDrag(drag_obj) {
			if (drag_obj.start_time.length === 0 && drag_obj.end_time.length === 0) {
				this._updateTaskDate(drag_obj);
			} else {
				this._updateTaskTime(drag_obj);
			}
			
			this.onCancelTaskDrag();
		},
		cancelDrag () {
			this.dragTime = null;
			this.dragDay = null;	
			this.dragEvent = null;
			this.createEvent = null;
			this.createStart = null;
			this.extendOriginal = null;
			this.mousedownFired = false;
		},
		onCancelTaskDrag() {
			this.drag_msg = '';
			this.drag_event = null;
			this.drag_visible = false;
			this.initEevent();
		},
		extendBottom (event) {
			this.createEvent = event;
			this.createStart = new Date(event.start_date).getTime();
			this.extendOriginal = new Date(event.end_date).getTime();
		},
		toTime (tms) {
			return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime();
		},
		roundTime (time, down = true) {
			const roundTo = 15; // minutes
			const roundDownTime = roundTo * 60 * 1000;

			return down
				? time - time % roundDownTime
				: time + (roundDownTime - (time % roundDownTime));
		},
		_isAbleDragLeave(event) {
			let ableDragging = true;
			
			if (event.leave_paid) {
				ableDragging = false;
			}
			if (event.leave_approved) {
				ableDragging = false;
			}
			if (!event.leave_paid && !event.leave_approved) {
				if (event.employee_id === this.userAddressId) {
					ableDragging = true;
				} else {
					if (this.onlyAmendOwnEventsPrivilege) {
						ableDragging = false;
					} else {
						if (this.approveLeaveEventsPrivilege) {
							ableDragging = true;
						} else {
							ableDragging = false;
						}
					}
				}
			}

			return ableDragging;
		},
		_isAbleDragHoliday(event) {
			let ableDragging = true;
			
			if (event.leave_paid) {
				ableDragging = false;
			}
			if (event.leave_approved) {
				ableDragging = false;
			}
			if (!event.leave_paid && !event.leave_approved) {
				if (this.modifyPubHolPrivilege) {
					ableDragging = true;
				} else {
					ableDragging = false;
				}
			}

			return ableDragging;
		},
		/** calendar item */
		onMoreClick({date}, nativeEvent) {
			const more_events_task = this.tasks.filter(e => {
				const start_date = moment(e.start_date, 'Do MMM YYYY').format('YYYY-MM-DD');
				const end_date = moment(e.end_date, 'Do MMM YYYY').format('YYYY-MM-DD');
				return this._isDuringDate(start_date, end_date, date);
			});
			more_events_task.forEach(m => {
				m['type'] = Event_Task;
				m['budget_left'] = this._getBudgetLeft(m);
			});

			const more_events_timesheet = this.timesheets.filter(e => {
				const timesheet_date = e.date;
				return timesheet_date === date;
			});
			more_events_timesheet.forEach(m => {
				m['type'] = Event_Timesheet;
			});

			const more_events_leave = this.leaves.filter(e => {
				const start_date = moment(e.start_date).format('YYYY-MM-DD');
				const end_date = moment(e.end_date).format('YYYY-MM-DD');
				return this._isDuringDate(start_date, end_date, date);
			});
			more_events_leave.forEach(m => {
				m['type'] = Event_Leave;
			});

			const more_events_holiday = this.holidays.filter(e => {
				const start_date = moment(e.start_date).format('YYYY-MM-DD');
				const end_date = moment(e.end_date).format('YYYY-MM-DD');
				return this._isDuringDate(start_date, end_date, date);
			});
			more_events_holiday.forEach(m => {
				m['type'] = Event_Holiday;
			});

			const more_events_item = this.items.filter(e => {
				const item_date = moment(e.date).format('YYYY-MM-DD');
				return item_date === date;
			});
			more_events_item.forEach(m => {
				m['type'] = Event_Item;
			});

			const more_events_event = this.other_events.filter(e => {
				const start_date = moment(e.start_date).format('YYYY-MM-DD');
				const end_date = moment(e.end_date).format('YYYY-MM-DD');
				return this._isDuringDate(start_date, end_date, date);
			});
			more_events_event.forEach(m => {
				m['type'] = Event_Events;
			});

			const more_events = [...more_events_task, ...more_events_timesheet, ...more_events_leave, ...more_events_item, ...more_events_holiday, ...more_events_event];
		
			const open = () => {
				this.moreEvent = more_events;
				this.moreElement = nativeEvent.target;
				requestAnimationFrame(() => requestAnimationFrame(() => this.moreOpen = true));
			}

			if (this.moreOpen) {
				this.moreOpen = false;
			} else {
				open();
			}

			nativeEvent.stopPropagation();
		},
		showEvent({ nativeEvent, event }) {
			if (event.type !== Event_Item || this.$vuetify.breakpoint.smAndDown || this.types_select === 'month') return;
			
			const open = () => {
				this.selectedEvent = event
				this.selectedElement = nativeEvent.target
				requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
			}

			if (this.selectedOpen) {
				this.selectedOpen = false
				requestAnimationFrame(() => requestAnimationFrame(() => open()))
			} else {
				open()
			}

			nativeEvent.stopPropagation()
		},
		onEditMenuItem(task) {
			this.task_detail_item = task;
			this.task_detail_visible = true;
		},
		onShareMenuItem(task_id) {
			this.share_task_id = task_id;
			this.share_visible = true;
		},
		onAdditemMenuItem(task, isCalendar=true) {
			if (!isCalendar) {
				task['type'] = Event_Task;
			}

			this.item_detail_item = task;
			this.item_detail_visible = true;
			this.isItemDuplication = true;
		},
		onFindTimesheetMenuItem(task_id) {
			this.find_timesheet_id = task_id;
		},
		onDeleteMenuItem(task, isCalendar=true, worklist=null) {
			this.delete_task = {
				id: task.id,
				title: task.title,
				isCalendar: isCalendar,
				type: task.type,
				worklist: worklist
			}
			
			this.delete_visible = true;
		},
		onStatusChange(status_obj, isCalendar=true, worklist=null) {
			this.progress_visible = true;

			const url = `/api/tasks/${status_obj.task_id}/set_status?status_id=${status_obj.status_id}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason} = val.data;

					if (status == "OK") {
						if (this.progress_visible) {
							this.progress_visible = false;
						}
						this.notice_text.push(`Status has been changed successfully`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						if (isCalendar) {
							this.initEevent();
						} else {
							const status_data = data.status;
							this.worklists.forEach(w => {
								if (w.id === worklist.id) {
									w['tasks'].forEach(t => {
										if (t.id === status_obj.task_id) {
											t['status'] = status_data;
										}
									});
								}
							});
						}

					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		onDuplicateMenuItem(task, isCalendar=true, worklist=null) {
			if (isCalendar) {
				this.task_detail_item = task;
				this.isDuplication = true;
				this.task_create_visible = true;
			}

			if (!isCalendar) {
				this.progress_visible = true;

				const url = `/api/tasks/${task.id}?comments=true&worked_on=true`;
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const {status, data, reason} = val.data;

						if (status == "OK") {
							this._createTask(data, isCalendar, worklist);
						} else {
							this.error_msg = reason;
						}
					})
					.catch((e) => {
						this.error_msg = e.message;
					});
			}
		},
		onCreateSubTask(task, isCalendar=true, worklist=null) {
			this.task_detail_item = task;
			if (!isCalendar) {
				this.update_worklist = worklist;
			}
			this.isSubTaskCreation = true;
			this.task_create_visible = true;
		},
		onLogTime(task_id) {
			const task_obj = this.tasks.filter(t => { return t.id === task_id });

			if (task_obj[0].kind) {
				this.logtime_task_id = task_id;
			} else {
				this.timesheet_create_visible = true;
				this.timesheet_create_task_id = task_id;
			}
		},
		onClickTaskMenuItem(key, task) {
			if (key === 'edit') {
				this.onEditMenuItem(task);
			}
			if (key === 'duplicate') {
				this.onDuplicateMenuItem(task)
			}	
			if (key === 'additem') {
				this.onAdditemMenuItem(task);
			}
			if (key === 'find') {
				this.onFindTimesheetMenuItem(task.id);
			}
			if (key === 'share') {
				this.onShareMenuItem(task.id);
			}
			if (key === 'subtask') {
				this.onCreateSubTask(task)
			}
		},
		onClickTimesheetMenuItem(key, timesheet) {
			if (key === 'edit') {
				this.timesheet_detail_item = timesheet;
				this.timesheet_detail_visible = true;
			}
			if (key === 'duplicate') {
				this.timesheet_detail_item = timesheet;
				this.timesheet_detail_visible = true;
				this.isAddTimesheet = true;
			}	
			if (key === 'additem') {
				this.item_detail_item = timesheet;
				this.item_detail_visible = true;
				this.isItemDuplication = true;
			}
		},
		onDeleteTimesheet(timesheet, isCalendar=true) {
			const title = timesheet.task ? timesheet.task.display_name : timesheet.kind.display_name;
			this.delete_task = {
				id: timesheet.id,
				title: title,
				isCalendar: isCalendar,
				type: timesheet.type
			}
			
			this.delete_visible = true;
		},
		onClickLeaveMenuItem(key, leave) {
			if (key === 'edit') {
				this.$router.push({ name: "Edit Leave", params: { id: leave.id }});
			}

			if (key === 'approved') {
				this._approveLeave(leave.id, leave.description);
			}

			if (key === 'unapprove') {
				this._unapproveLeave(leave.id, leave.description)
			}
		},
		onDeleteLeave(leave, isCalendar=true) {
			this.delete_task = {
				id: leave.id,
				title: leave.description,
				isCalendar: isCalendar,
				type: leave.type
			}
			
			this.delete_visible = true;
		},
		onClickItemMenuItem(key, item) {
			if (key === 'edit') {
				this.item_detail_item = item;
				this.item_detail_visible = true;
			}
			if (key === 'duplicate') {
				this.item_detail_item = item;
				this.item_detail_visible = true;
				this.isItemDuplication = true;
			}	
		},
		onDeleteItemMenuItem(item, isCalendar=true) {
			this.delete_task = {
				id: item.id,
				title: '',
				isCalendar: isCalendar,
				type: item.type
			}
			
			this.delete_visible = true;
		},
		onClickHolidayMenuItem(key, event) {
			if (key === 'edit') {
				this.holiday_detail_item = event;
				this.holiday_detail_visible = true;
			}

			if (key === 'approved') {
				this._approveLeave(event.id, event.description, true);
			}

			if (key === 'unapprove') {
				this._unapproveLeave(event.id, event.description, true)
			}
		},
		onDeleteHoliday(event, isCalendar=true) {
			this.delete_task = {
				id: event.id,
				title: event.description,
				isCalendar: isCalendar,
				type: event.type,
			}
			
			this.delete_visible = true;
		},
		onClickEventMenuItem(key, event) {
			if (key === 'addtimesheet') {
				const job_obj = {
					job_code: event.job.code,
					job_code_sort: event.job.display_name,
					job_id: event.job.id,
					id: event.job.id
				};
				this.add_timesheet_job = job_obj;
				this.add_timesheet_visible = true;
			}
			if (key === 'edit') {
				this.event_detail_item = event;
				this.isEventDuplication = false;
				this.event_detail_visible = true;
			}

			if (key === 'duplicate') {
				this.event_detail_item = event;
				this.isEventDuplication = true;
				this.event_detail_visible = true;
			}

			if (key === 'invite') {
				this.event_detail_item = event;
				this.email_visible = true;
			}
		},
		onDeleteEvent(event, isCalendar=true) {
			let repeat_event = true;
			if (event.repeat_unit === 0) {
				repeat_event = false;
			} else {
				let end_date_by_unit = '';
				
				// daily
				if (event.repeat_unit === 1) {
					const days_tmp = event.repeat_value - 1;
					end_date_by_unit = moment(event.end_date).add(days_tmp, 'd').format('YYYY-MM-DD');
				}

				// weekly
				if (event.repeat_unit === 5) {
					const days_tmp = 7 * event.repeat_value - 1;
					end_date_by_unit = moment(event.end_date).add(days_tmp, 'd').format('YYYY-MM-DD');
				}

				// monthly
				if (event.repeat_unit === 3) {
					const days_tmp = event.repeat_value;
					end_date_by_unit = moment(event.end_date).add(days_tmp, 'M').format('YYYY-MM-DD');
				}
				
				if (event.repeat_end && event.repeat_end.length !== 0 && (event.repeat_end === moment(event.end_date).format('YYYY-MM-DD') || event.repeat_end <= end_date_by_unit)) {
					repeat_event = false;
				}
			}

			this.delete_task = {
				id: event.id,
				title: event.description,
				isCalendar: isCalendar,
				type: event.type,
				repeat: repeat_event,
				iteration: event.iteration
			}

			this.delete_visible = true;
		},
		onEmailSend(invitees, event_detail_item) {
			const params_obj = {};
			params_obj['start_date'] = moment(event_detail_item.start_datetime, 'YYYYMMDD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss Z');
			params_obj['end_date'] = moment(event_detail_item.end_datetime, 'YYYYMMDD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss Z');

			const invitees_arr = invitees.map(invitee => {
				const obj = {
					id: invitee.id !== 0 ? invitee.id : 0,
					accepted: invitee.accepted,
					is_deleted: false,
					pay_processed: false,
					send_email: invitee.employee.send_email,
					email_id: invitee.employee.email,
					is_organiser: false
				};

				if (invitee.employee.contact_id) {
					obj['contact_id'] = invitee.employee.contact_id;
				} else {
					obj['employee_id'] = invitee.employee.id;
				}

				return obj;
			});

			params_obj['invitees'] = invitees_arr;
			
			const url = `/api/events/${event_detail_item.id}/invitees`;
			axios
				.post(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
						this.notice_text.push(`Event ‘(${event_detail_item.description})’ has been invited successfully`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						this.onTaskClose();

						this.initEevent();
						
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					if (this.progress_visible) {
						this.progress_visible = false;
					}
				});
		},
		showTaskDetails(task) {
			if (task.job_valid) {
				this.task_detail_item = task;
				this.task_detail_visible = true;
			}
		},
		showTimesheetDetails(timesheet) {
			if (timesheet.job_valid) {
				this.timesheet_detail_item = timesheet;
				this.isAddTimesheet = true;
				this.timesheet_detail_visible = true;
			}
		},
		showLeaveDetails(leave) {
			const path = this.$route.path;
			this.$router.push({ name: "Edit Leave", params: { id: leave.id, path: path } });
		},
		showPublicHolidayDetails(event) {
			this.holiday_detail_item = event;
			this.holiday_detail_visible = true;
		},
		showItemDetails(item) {
			this.item_detail_item = item;
			this.item_detail_visible = true;
		},
		showEventDetails(event) {
			this.event_detail_item = event;
			this.event_detail_visible = true;
		},
		onTaskClose(worklist=null) {
			this.moreOpen = false;
			this.task_detail_item = null;
			this.task_detail_visible = false;
			this.task_create_visible = false;
			this.isDuplication = false;
			this.isSubTaskCreation = false;
			this.timesheet_detail_item = null;
			this.timesheet_detail_visible = false;
			this.timesheet_create_visible = false;
			this.timesheet_create_task_id = 0;
			this.isAddTimesheet = false;
			this.item_detail_item = null;
			this.item_detail_visible = false;
			this.isItemDuplication = false;
			this.add_timesheet_visible = false;
			this.add_timesheet_job = null;
			this.event_detail_visible = false;
			this.event_detail_item = null;
			this.isEventDuplication = false;
			this.email_visible = false;
			this.holiday_detail_visible = false;
			this.holiday_detail_item = null;
			this.initEevent();
			if (worklist) {
				this._getTasklist(worklist.id, worklist.settings);
			}
		},
		onDeleteCancel() {
			this.delete_visible = false;
			this.delete_task = null;
		},
		onDelete(mode) {
			this.delete_visible = false;
			if (this.delete_task.type === Event_Task) {
				this._deleteTask(this.delete_task.id, this.delete_task.title, this.delete_task.isCalendar, this.delete_task.worklist);
			} else if(this.delete_task.type === Event_Timesheet) {
				this._deleteTimesheet(this.delete_task.id, this.delete_task.title);
			} else if(this.delete_task.type === Event_Item) {
				this._deleteItem(this.delete_task.id);
			} else if(this.delete_task.type === Event_Events) {
				this._deleteEvent(this.delete_task.id, this.delete_task.title, this.delete_task.repeat, mode, this.delete_task.iteration);
			} else if(this.delete_task.type === Event_Holiday) {
				this._deleteHoliday(this.delete_task.id, this.delete_task.title);
			} else {
				this._deleteLeave(this.delete_task.id, this.delete_task.title);
			}
		},
		onCopyLink(isSuccessful) {
			this.share_visible = false;
			this.share_tasklist_visible = false;

			const text = isSuccessful ? 'Link copied successfully.':'Link copied failed.';
			this.notice_text.push(text);
			this.visible_notice = true;
			this.tid = setTimeout(this._close, 2000);
		},
		onSaveAs(params) {
			const param = {
				id: 0,
				class: this.save_as_item.class,
				name: typeof(params) === 'string' ? params : params.name,
				settings: typeof(this.save_as_item.settings) === 'string' ? this.save_as_item.settings :JSON.stringify(this.save_as_item.settings),
				is_dynamic: typeof(params) === 'string' ? this.save_as_item.is_dynamic : params.dynamic,
			};
			this._createTasklist(param, this.save_as_item.owner,);
		},
		onLogTimesheetClose() {
			this.logtime_task_id = 0;
			this.initEevent();
		},
		onCloseSearch() {
			this.search_visible = false;
			this.search_item = null;
		},
		async onSearch(param) {
			if (param.id === 0) {
				const index = Panel_Items.findIndex(p => { return p.value === 'mytask'});
				if (!this.panel.includes(index)) {
					this.loading_worklist = true;
					await this._getWorklist();
					this.panel.push(index);
				}
			}

			this._searchTasks(param.id, param.settings);
			this.onCloseSearch();
		},
		onTaskUnsavedCancel() {
			this.current_unsaved_ids = [];
			this.unsaved_visible = false;
			this.panel = this.panel.filter(p => { return p !== this.panel_index });
		},
		onSaveAll() {
			const unsaved_tasklist = this.worklists.filter(t => { return t.id ===  this.current_unsaved_ids[0]});
			const unsaved_tasklist_other = this.other_worklists.filter(t => { return t.id ===  this.current_unsaved_ids[0]});
			const unsaved_arr = unsaved_tasklist.length !== 0 ? unsaved_tasklist : unsaved_tasklist_other;
			this.onSaveChange(unsaved_arr[0]);
		},
		/** left menu */
		onMenuClick() {
			if (!this.$vuetify.breakpoint.xs) {
				this.mini = !this.mini;
			}
			if (this.$vuetify.breakpoint.xs) {
				this.mini = false;
				this.drawer = !this.drawer;
			}
		},
		onCalendarsClick(item_obj) {
			this.assigned_to = item_obj.assigned;

			const selected_arr = item_obj.assigned.filter(a => { return a.id === item_obj.id });
			if (selected_arr.length === 0) {
				if (this.assigned_to.length === 1) {
					this.initEevent();
				} else {
					this.tasks = this.tasks.filter(t => { return t.color_id !== item_obj.id });
					this.timesheets = [];
					this.items = [];
					this.leaves = [];
					this.holidays = [];
				}
				
			} else {
				this.initEevent();
			}

			if (this.assigned_to.length > 1) {
				this.view_options_select = this.view_options_select.filter(v => { return v.value !== Event_Timesheet && v.value !== Event_Leave && v.value !== Event_Item && v.value !== Event_Holiday });
				this.timesheets = [];
				this.items = [];
				this.leaves = [];
				this.holidays = [];
			}
			
			this.$emit('display', item_obj.assigned);
		},
		getWorklistClass(worklist_id) {
			return typeof(worklist_id) === 'string' ? true: false;
		},
		onOpenTasklist(item_id, item_settings) {
			if (this.worklist_open_id === item_id) {
				this.worklist_open_id = 0;
			} else {
				this.worklist_open_id = item_id;
				this._getTasklist(item_id, item_settings);
			}
		},
		onClickMenuItem(param, item) {
			const key = typeof(param) === 'string' ? param : param.key;
			if (key === 'search') {
				let settings = null;

				if (typeof(item.settings) === 'string') {
					settings = JSON.parse(item.settings);
				}
				if (typeof(item.settings) === 'object') {
					settings = item.settings;
				}

				const item_obj = {
					id: item.id,
					name: item.name,
					settings: settings
				};
				
				const item_tmp = {};
				for (const [key, value] of Object.entries(item_obj)) {
					if (key === 'settings') {
						if (typeof(value) === 'string') {
							item_tmp[`${key}`] = JSON.parse(value);
						}
						if (typeof(value) === 'object') {
							item_tmp[`${key}`] = value;
						}
					} else {
						item_tmp[`${key}`] = value;
					}
				}

				this.search_item = item_tmp;
				this.search_visible = true;
			}
			if (key === 'share') {
				if (item.is_owned) {
					this._loadWorklistItem(item.id);
					this.share_tasklist_visible = true;
				} 
			}
			if (key === 'pin') {
				this._pinTasklist(item, param.enabled);
			}
			if (key === 'rename') {
				if (item.is_owned) {
					this.edit_id = item.id;
				}
			}
			if (key === 'save') {
				this.save_as_item = item;
				this.save_as_visible = true;
			}
		},
		onBlur(e, item) {
			const name = e.target.value;

			const param = {
				id: item.id,
				class: item.class,
				name: name,
				settings: typeof(item.settings) === 'string' ? item.settings :JSON.stringify(item.settings),
				is_dynamic: item.is_dynamic,
			};

			this._updateTasklist(item.id, item.owner, param);
		},
		onKeyDown(e, item) {
			if (e.keyCode === 13) {
				const name = e.target.value;
				
				const param = {
					id: item.id,
					class: item.class,
					name: name,
					settings: typeof(item.settings) === 'string' ? item.settings :JSON.stringify(item.settings),
					is_dynamic: item.is_dynamic,
				};

				this._updateTasklist(item.id, item.owner, param);
			}
		},
		onDeleteMenuTasklist(item) {
			this.delete_item = item;
			this.delete_tasklist_visible = true;
		},
		onDeleteTasklistCancel() {
			this.delete_tasklist_visible = false;
			this.delete_item = null;
		},
		onDeleteTasklist() {
			this.delete_tasklist_visible = false;
			this._deleteTasklist(this.delete_item.id, this.delete_item.name);
		},
		onSaveChange(item) {
			if (item.id.startsWith('0') ) {
				this.save_as_item = item;
				this.save_as_visible = true;
			} else {
				const id = Number(item.id);

				const param = {
					id: id,
					class: item.class,
					name: item.name,
					settings: typeof(item.settings) === 'string' ? item.settings :JSON.stringify(item.settings),
					is_dynamic: item.is_dynamic,
				};
				this._updateTasklist(item.id, item.owner, param);
			}
		},
		onDataPickerChanged(date) {
			this.calendar_date = date;

			const date_range = this._setDateRange();
			this.start_custom_weekly = date_range.start_date;
			this.end_custom_weekly = date_range.end_date;

			this.initEevent();
		},
		onFilterChange(worklist) {
			const task_filter = this.filterTasks(worklist.tasksOrigin);

			this.worklists.forEach(w => {
				if (w.id === worklist.id) {
					w.tasks = task_filter;
				}
			});
		},
		filterTasks(task_origin) {
			let res_arr = task_origin;
			const status_ids = this.statuses_selected.map(s => { return s.id });
			if (status_ids.length !== 0) {
				res_arr = res_arr.filter(d => { return status_ids.includes(d.status.id) });
			} else {
				res_arr = [];
			}

			const job_ids = this.job_selected.map(j => { return j.id });
			if (job_ids.length !== 0) {
				res_arr = res_arr.filter(d => { return job_ids.includes(d.job.id) });
			} else {
				res_arr = [];
			}
			
			const client_ids = this.client_selected.map(c => { return c.id });
			if (client_ids.length !== 0) {
				res_arr = res_arr.filter(d => { return client_ids.includes(d.client.id) });
			} else {
				res_arr = [];
			}

			const taskname_key = this.taskname_key === null ? '': this.taskname_key.toUpperCase();
			const res_arr_tmp = res_arr.filter(f => {
				const A = f.title.toUpperCase();
				const B = f.job.code.toUpperCase();
				const C = f.job.name.toUpperCase();
				const D = f.phase.name.toUpperCase();
				const E = f.client.name.toUpperCase();
				const F = f.description.toUpperCase();
				return A.includes(taskname_key) || B.includes(taskname_key) || C.includes(taskname_key) || D.includes(taskname_key) || E.includes(taskname_key) || F.includes(taskname_key);
			});
			res_arr = res_arr_tmp;

			if (this.isShowPast) {
				const res_arr_tmp = res_arr.filter(d => { 
					const end_date = moment(d.end_date, 'Do MMM YYYY').format('YYYY-MM-DD');
					return this._isPastTask(end_date)
				});
				res_arr = res_arr_tmp;
			}
			
			return res_arr;
		},
		_getCapacity(params) {
			return new Promise((resolve, reject) => {
				let url = `/api/addressbook/capacity_data`;
				if (params.length > 0) {
					url+= "?" + params.join('&');
				}
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						let json = val.data;

						// For some reason axios isn't always converting our data
						if (typeof(json) === "string") {
							json = JSON.parse(json);
						}

						const { status, data, reason } = json;
						if (status === 'OK') {
							resolve(data);
							
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});

			});
		},
		_setTaskParams(suggested_mode, start_date, end_date, id, type) {
			const params = [];

			/*  assign_mode=2, 2 = anyone */
			params.push("assign_mode=" + 2);

			/*  budget_types=[0, 1, 2, 3], 0=No units/value, 1=Value only, 2=Minutes + Value, 3=Units + Value */
			params.push("budget_types=" + [0, 1, 2, 3]);

			/*  statusses */
			const status_ids = this.statusses.map(s => { return s.id });
			params.push("statusses=" + status_ids);			

			/*  employees */
			if (type === ALLEMPLOYEES) {
				params.push("employees=" + id);
			}

			/*  roles */
			if (type === ROLES) {
				params.push("roles=" + id);
			}

			/*  departments */
			if (type === DEPARTMENTS) {
				params.push("departments=" + id);
			}

			/*  priorities, level1~level5 => [0, 1, 2, 3, 4] */
			params.push("priorities=" + [0, 1, 2, 3, 4]);

			/*  suggested_mode, 0 - any, 1 = suggested, 2 = not suggested */
			params.push("suggested_mode=" + suggested_mode);

			/*  date_mode=2, 2 = date range */
			params.push("date_mode=" + 2);

			/*  start_date, end_date */
			params.push("start_date=" + encodeURIComponent(start_date));
			params.push("end_date=" + encodeURIComponent(end_date));

			return params
		},
		_setTimesheetParams(employees, start_date, end_date) {
			const params = [];

			/* ids of employees and/or freelancers */
			params.push("employees=" + employees);

			/*  start_date, end_date */
			params.push("start_date=" + encodeURIComponent(start_date));
			params.push("end_date=" + encodeURIComponent(end_date));
			
			return params
		},
		_setLeaveParams(employees, start_date, end_date) {
			const params = [];

			params.push("employees=" + employees);
			params.push("start_date=" + encodeURIComponent(start_date));
			params.push("end_date=" + encodeURIComponent(end_date));
			params.push("event_types=" + [2,3,4,5,6]);

			return params
		},
		_setEventParams(employees, start_date, end_date) {
			const params = [];

			params.push("employees=" + employees);
			params.push("start_date=" + encodeURIComponent(start_date));
			params.push("end_date=" + encodeURIComponent(end_date));

			/** other event + public holiday, not including leave */
			params.push("event_types=" + [0, 1, 2]);

			return params
		},
		_setProcessParams(holidays, leaves, events, tasks, capacity_by_date) {
			/** get holiday_per_day */
			holidays.forEach(holiday => {
				if (holiday.leave_approved || holiday.leave_paid) {
					const day_init = moment(holiday.start_date);
					const day_end = moment(holiday.end_date);
					const diff = day_end.diff(day_init, 'days');

					if (diff === 0) {
						const key = moment(holiday.start_date).format('YYYY-MM-DD');
						if (capacity_by_date[`${key}`]) {
							const duration = capacity_by_date[`${key}`].holiday + holiday.duration;
							capacity_by_date[`${key}`].holiday = duration;
						}
					} else {
						const valid_day_arr = [];
						for (let index = 0; index < diff + 1; index++) {
							const date = moment(day_init).add(index, 'days').format('YYYY-MM-DD');
							if (this.workdays.includes(date)) {
								valid_day_arr.push(date);
							}
						}
						const duration_per_day = valid_day_arr.length !== 0 ? Math.ceil(holiday.duration) / valid_day_arr.length : 0;

						for (let index = 0; index < diff + 1; index++) {
							const key = moment(day_init).add(index, 'days').format('YYYY-MM-DD');
							if (capacity_by_date[`${key}`]) {
								const duration = capacity_by_date[`${key}`].holiday + duration_per_day;
								capacity_by_date[`${key}`].holiday = duration;
							}
						}
					}
				}
			});

			/** get leave_per_day */
			leaves.forEach(leave => {
				if (leave.leave_approved || leave.leave_paid) {
					const day_init = moment(leave.start_date);
					const day_end = moment(leave.end_date);
					const diff = day_end.diff(day_init, 'days');

					if (diff === 0) {
						const key = moment(leave.start_date).format('YYYY-MM-DD');
						if (capacity_by_date[`${key}`]) {
							const duration = capacity_by_date[`${key}`].leave + leave.duration;
							capacity_by_date[`${key}`].leave = duration;
						}
					} else {
						for (let index = 0; index < diff + 1; index++) {
							const date = moment(day_init).add(index, 'days').format('YYYY-MM-DD');
							
							if (capacity_by_date[`${date}`]) {
								const duration_per_day = (leave.duration - capacity_by_date[`${date}`].available) >= 0 ? capacity_by_date[`${date}`].available : leave.duration;

								const existed_leaves = leaves.filter(l => { return (l.leave_approved || l.leave_paid) && !l.all_day && date === moment(l.start_date).format('YYYY-MM-DD') });
								let existed_leave_hours = 0;
								if (existed_leaves.length !== 0) {
									const duration_arr = existed_leaves.map(l => {return l.duration });
									existed_leave_hours = duration_arr.reduce( (accumulator, currentValue) => accumulator + currentValue);
								}

								const existed_holiday = capacity_by_date[`${date}`].holiday;

								const over = duration_per_day >= capacity_by_date[`${date}`].available ? (existed_leave_hours + existed_holiday) : 0;
								const duration = capacity_by_date[`${date}`].leave + (duration_per_day - over);
								capacity_by_date[`${date}`].leave = duration;
							}
						}
					}
				}
			});

			/** get event_per_day */
			events.forEach(event => {
				if (event.event_type.plan_type === Event_Type_Busy) {
					const day_init = moment(event.start_date);
					const day_end = moment(event.end_date);
					const diff = day_end.diff(day_init, 'days');

					if (diff === 0) {
						const key = moment(event.start_date).format('YYYY-MM-DD');
						if (capacity_by_date[`${key}`]) {
							let event_duration_tmp = 0;

							if (event.all_day) {
								event_duration_tmp = event.duration;
							} else {
								const start = moment(event.start_datetime, 'YYYYMMDD HH:mm:ss');
								const end = moment(event.end_datetime, 'YYYYMMDD HH:mm:ss');
								const diff = end.diff(start, 'm');
								event_duration_tmp = diff;
							}
							
							const duration = capacity_by_date[`${key}`].event + event_duration_tmp;
							capacity_by_date[`${key}`].event = duration;
						}
					} else {
						const valid_day_arr = [];
						for (let index = 0; index < diff + 1; index++) {
							const date = moment(day_init).add(index, 'days').format('YYYY-MM-DD');
							valid_day_arr.push(date);

							/**
							 * un-workday can be include in capacity bar calculation
								if (this.workdays.includes(date)) {
									valid_day_arr.push(date);
								}
							*/
						}
						let event_duration_tmp = 0;
								
						if (event.all_day) {
							event_duration_tmp = event.duration;
						} else {
							const start = moment(event.start_date);
							const end = moment(event.end_date);
							const diff = end.diff(start, 'm');
							event_duration_tmp = diff;
						}

						const duration_per_day = Math.ceil(event_duration_tmp / valid_day_arr.length);

						for (let index = 0; index < diff + 1; index++) {
							const key = moment(day_init).add(index, 'days').format('YYYY-MM-DD');
							if (capacity_by_date[`${key}`]) {
								const duration = capacity_by_date[`${key}`].event + duration_per_day;
								capacity_by_date[`${key}`].event = duration;
							}
						}
					}
				}
			});

			const today = moment().format('YYYY-MM-DD');
			/** get task_per_day */
			tasks.forEach(task => {
				if (task.status.type === config.status_active_type) {
					const day_init = moment(task.start_date, 'Do MMM YYYY');
					const day_end = moment(task.end_date, 'Do MMM YYYY');
					const diff = day_end.diff(day_init, 'days');

					const workdays = task.workdays.split('');
					const workday_boolen = workdays.map(w => { return w === '1' ? true: false });
				
					const valid_day_arr = [];
					for (let index = 0; index < diff + 1; index++) {
						const date = moment(day_init).add(index, 'days').format('YYYY-MM-DD');
						const week_str = moment(date).format('dddd');
						const week_index = WeekOrder.indexOf(week_str);
					
						if (workday_boolen[`${week_index}`] && date >= today) {
							valid_day_arr.push(date);
						}

						/**
						 * un-workday can be include in capacity bar calculation
							if (this.workdays.includes(date) && workday_boolen[`${week_index}`] && date >= today) {
								valid_day_arr.push(date);
							}
						 */
					}

					/** get the remain budget for a task */
					const remain_budget = task.budget - task.actual >= 0 ? task.budget - task.actual : 0;
					
					/** get the remain budget per a day */
					const remain_budget_per_day = valid_day_arr.length !== 0 ? Math.ceil(remain_budget / valid_day_arr.length) : 0;

					for (let index = 0; index < diff + 1; index++) {
						const key = moment(day_init).add(index, 'days').format('YYYY-MM-DD');
						if (capacity_by_date[`${key}`] && key >= today) {
							const duration = capacity_by_date[`${key}`].task + remain_budget_per_day;
							capacity_by_date[`${key}`].task = duration;
						}
					}
				}
			});

			const progress_by_date_tmp = {};
			for (const key of Object.keys(capacity_by_date)) {
				/** init minutes */
				const unavailable_minutes = 60 * 8;
				const holiday_minutes = capacity_by_date[key].holiday;
				const leave_minutes = capacity_by_date[key].leave;
				const event_minutes = capacity_by_date[key].event;
				const timesheet_minutes = capacity_by_date[key].timesheet;
				const task_minutes = capacity_by_date[key].task;
				const available_minutes = capacity_by_date[key].available - holiday_minutes - leave_minutes - event_minutes - timesheet_minutes - task_minutes;

				/** init percent */
				const is_unavailable = capacity_by_date[key].available === 0;
				const elements_arr = is_unavailable ? [unavailable_minutes, event_minutes, task_minutes]:[holiday_minutes, leave_minutes, event_minutes, timesheet_minutes, task_minutes, available_minutes];
				const display_elements = elements_arr.filter(e => {return e > 0});
				const percent_str = (100 / display_elements.length).toFixed(2);
				const percent = Number.parseFloat(percent_str);

				const percent_un = is_unavailable ? percent : 0;
				const percent_ph = holiday_minutes <= 0 ? 0: percent;
				const percent_leave = leave_minutes <= 0 ? 0 : percent;
				const percent_event = event_minutes <= 0 ? 0 : percent;
				const percent_timesheet = timesheet_minutes <= 0 ? 0 : percent;
				const percent_task = task_minutes <= 0 ? 0 : percent;
				const percent_available = available_minutes <= 0 ? 0 : percent;

				/** init capacity info */
				const hour_un = {};
				hour_un['budget'] = '';
				hour_un['over'] = '';

				const hour_ph = {};
				hour_ph['budget'] = this._minutesToBudget(holiday_minutes, true);
				hour_ph['over'] = '';

				const hour_leave = {};
				hour_leave['budget'] = this._minutesToBudget(leave_minutes, true);
				hour_leave['over'] = '';

				const diff_event = capacity_by_date[key].available - (is_unavailable ? 0 : holiday_minutes) - (is_unavailable ? 0 : leave_minutes) - event_minutes;
				const hour_event = {};
				hour_event['budget'] = this._minutesToBudget(event_minutes, true);
				hour_event['over'] = diff_event < 0 ? this._minutesToBudget(Math.abs(diff_event)) : '';
				const over_event = diff_event < 0 ? true: false;

				const hour_timesheet = {};
				hour_timesheet['budget'] = this._minutesToBudget(timesheet_minutes, true);
				hour_timesheet['over'] = '';

				const diff_task = capacity_by_date[key].available - (is_unavailable ? 0 : holiday_minutes) - (is_unavailable ? 0 : leave_minutes) - event_minutes - task_minutes;
				const hour_task = {};
				hour_task['budget'] = this._minutesToBudget(task_minutes, true);
				hour_task['over'] = diff_task < 0 ? this._minutesToBudget(Math.abs(diff_task)) : '';
				const over_task = diff_task < 0 ? true : false;

				const hour_available = {};
				hour_available['budget'] = this._minutesToBudget(available_minutes, true);
				hour_available['over'] = '';

				let all_progress_by_date = [];

				if (is_unavailable) {
					all_progress_by_date = [
						{ key: 'UNAVAILABLE', percent: percent_un, hour: hour_un, color: '#FFEFEF',text_color:'#F45252',  over: false },
						{ key: 'events', percent: percent_event, hour: hour_event, color: '#609800', text_color:'#609800', over: over_event },
						{ key: 'tasks', percent: percent_task, hour: hour_task, color: '#82899B', text_color:'#192A3E', over: over_task },
					];
				} else {
					all_progress_by_date = [
						{ key: 'public holiday', percent: percent_ph, hour: hour_ph, color: '#C18014',text_color:'#C18014',  over: false },
						{ key: 'leave', percent: percent_leave, hour: hour_leave, color: '#C18014', text_color:'#C18014',  over: false },
						{ key: 'events', percent: percent_event, hour: hour_event, color: '#609800', text_color:'#609800', over: over_event },
						{ key: 'timesheets', percent: percent_timesheet, hour: hour_timesheet, color: '#3A7E9F', text_color:'#3A7E9F', over: false },
						{ key: 'tasks', percent: percent_task, hour: hour_task, color: '#82899B', text_color:'#192A3E', over: over_task },
						{ key: 'available', percent: percent_available, hour: hour_available, color: '#E8EAEC', text_color:'#192A3E', over: false },
					];
				}
				progress_by_date_tmp[key] = all_progress_by_date.filter(p => { return p.percent > 0});
			}

			return progress_by_date_tmp;
		},
		_setProcessParams_old(tasks, capacity_by_date) {
			const remain_days_per_task = {}; // =>T
			const remain_budget_per_task = {}; // =>R
			const date_existed_per_task_tmp = {};
			const today = moment().format('YYYY-MM-DD');

			tasks.forEach(t => {
				if (t.status.type !== config.status_active_type) return;
				
				const workdays = t.workdays.split('');
				const workday_boolen = workdays.map(w => { return w === '1' ? true: false });

				/** get dates for a task */
				const day_init = moment(t.start_date, 'Do MMM YYYY');
				const day_end = moment(t.end_date, 'Do MMM YYYY');
				const diff = day_end.diff(day_init, 'days');
				const date_arr = [];
				for (let index = 0; index < diff + 1; index++) {
					const date = moment(day_init).add(index, 'days').format('YYYY-MM-DD');
					const week_str = moment(date).format('dddd');
					const week_index = WeekOrder.indexOf(week_str);
					
					if (this.workdays.includes(date) && workday_boolen[`${week_index}`]) {
						date_arr.push(date);
					}
				}

				date_existed_per_task_tmp[`${t.id}`] = date_arr;

				/** get the remain days for a task */
				const remain_date_arr = date_arr.filter(d => { return d >= today });
				remain_days_per_task[`${t.id}`] = remain_date_arr.length;

				/** get the remain budget for a task */
				let remain_budget = 0;

				if (t.Timesheets) {
					const start_date = moment(t.start_date, 'Do MMM YYYY').format('YYYY-MM-DD');
					const date_flag = start_date < today ? today : start_date;
					const past_actual_arr = t.Timesheets.map(d => { return d.dated < date_flag ? d.actuals : 0 });
					const past_actual_sum = past_actual_arr.reduce(
						(accumulator, currentValue) => accumulator + currentValue
					);

					remain_budget = t.budget - past_actual_sum > 0 ? t.budget - past_actual_sum : 0;
				} else {
					remain_budget = t.budget;
				}
			
				remain_budget_per_task[`${t.id}`] = remain_budget;
			});

			/** init task_existed_per_day */
			const task_existed_per_day = {};
			for (const key of Object.keys(capacity_by_date)) {
				task_existed_per_day[`${key}`] = [];
			}

			/** get task id for each day */
			for (const key of Object.keys(task_existed_per_day)) {
				for (const [task_id, value] of Object.entries(date_existed_per_task_tmp))
					if (value.includes(key)) {
						task_existed_per_day[`${key}`].push(task_id);
					}
			}

			/** init timesheet_existed_per_day */
			const timesheet_existed_per_day = {};
			for (const key of Object.keys(capacity_by_date)) {
				timesheet_existed_per_day[`${key}`] = [];
			}

			/** get total timesheets for each day */
			for (const key of Object.keys(timesheet_existed_per_day)) {
				const recorded_obj = {};
				this.timesheet_calculate.forEach(t => {
					if (t.date === key) {
						if (t.task) {
							recorded_obj[`${t.task.id}`] = recorded_obj[`${t.task.id}`] ?  recorded_obj[`${t.task.id}`] + t.duration : t.duration;
						} else {
							recorded_obj[`0`] = recorded_obj[`0`] ?  recorded_obj[`0`] + t.duration : t.duration;
						}
					}
				});
				timesheet_existed_per_day[`${key}`] = recorded_obj;
			}


			const total_scheduled_per_day = {};
			const left_scheduled_per_day = {};
			for (const key of Object.keys(task_existed_per_day)) {
				let total_scheduled = 0;
				let left_scheduled = 0;
				const task_id_arr = task_existed_per_day[`${key}`];
				const timesheet_duration_by_date = timesheet_existed_per_day[`${key}`];

				task_id_arr.forEach(id => {
					const R = remain_budget_per_task[`${id}`];
					const T = remain_days_per_task[`${id}`];
					const D = timesheet_duration_by_date[`${id}`] ? timesheet_duration_by_date[`${id}`] : 0;

					/** what's on my plate */
					const total_scheduled_tmp = T === 0 ? 0 : Math.round(R / T);
					/** what's left on my plate */
					const left_scheduled_tmp = total_scheduled_tmp - D;

					total_scheduled += total_scheduled_tmp;
					left_scheduled += left_scheduled_tmp;
					// console.log('date:', key, ', task_id:', id, ', R:',  R, ', T:', T, ', D:', D, ', whats on my plate:', total_scheduled, ', whats left:', left_scheduled);
				})

				total_scheduled_per_day[`${key}`] = total_scheduled;
				left_scheduled_per_day[`${key}`] = left_scheduled;
			}

			const progress_by_date_tmp = {};
			for (const key of Object.keys(capacity_by_date)) {
				if (this._isPastTask(key)) {
					const total_tmp = capacity_by_date[key] ? capacity_by_date[key].capacity : 0;
					const timesheet_tmp = capacity_by_date[key] ? capacity_by_date[key].timesheet : 0;
					const remain_tmp = capacity_by_date[key] ? capacity_by_date[key].remain : 0;

					const scheduled_percent = total_tmp === 0 ? 0 : Math.floor((timesheet_tmp / total_tmp)* 100);
					const remain_percent = (100 - scheduled_percent) < 0 ? 0 : (100 - scheduled_percent);

					const scheduled_hour = {};
					scheduled_hour['capacity'] = total_tmp >= 0 ? this._minutesToBudget(Math.abs(total_tmp)) : '-'+this._minutesToBudget(Math.abs(total_tmp))
					if (timesheet_tmp !== 0) {
						scheduled_hour['timesheet'] = timesheet_tmp > 0 ? this._minutesToBudget(Math.abs(timesheet_tmp)) : '-'+this._minutesToBudget(Math.abs(timesheet_tmp))
					}
					scheduled_hour['remain'] = remain_tmp >= 0 ? this._minutesToBudget(Math.abs(remain_tmp)) : '-'+this._minutesToBudget(Math.abs(remain_tmp))

					const remain_hour = {};
					remain_hour['capacity'] = total_tmp >= 0 ? this._minutesToBudget(Math.abs(total_tmp)) : '-'+this._minutesToBudget(Math.abs(total_tmp))
					if (timesheet_tmp !== 0) {
						remain_hour['timesheet'] = timesheet_tmp > 0 ? this._minutesToBudget(Math.abs(timesheet_tmp)) : '-'+this._minutesToBudget(Math.abs(timesheet_tmp))
					}
					remain_hour['remain'] = remain_tmp >= 0 ? this._minutesToBudget(Math.abs(remain_tmp)) : '-'+this._minutesToBudget(Math.abs(remain_tmp))

					progress_by_date_tmp[key] = [
						{ percent: scheduled_percent, hour: scheduled_hour, over: timesheet_tmp > total_tmp },
						{ percent: remain_percent, hour: remain_hour, over: timesheet_tmp > total_tmp }
					];

				} else {
					const total_tmp = capacity_by_date[key] ? capacity_by_date[key].capacity : 0;
					const timesheet_tmp = capacity_by_date[key] ? capacity_by_date[key].timesheet : 0;
					const remain_tmp = capacity_by_date[key] ? capacity_by_date[key].remain : 0;
					const plate_tmp = total_scheduled_per_day[key] ? total_scheduled_per_day[key]: 0;
					const left_tmp = left_scheduled_per_day[key] ? left_scheduled_per_day[key]: 0;

					const scheduled_percent = total_tmp === 0 ? 0 : Math.floor((plate_tmp / total_tmp)* 100);
					const remain_percent = (100 - scheduled_percent) < 0 ? 0 : (100 - scheduled_percent);

					const scheduled_hour = {};
					scheduled_hour['capacity'] = total_tmp >= 0 ? this._minutesToBudget(Math.abs(total_tmp)) : '-'+this._minutesToBudget(Math.abs(total_tmp));
					scheduled_hour['plate'] = plate_tmp >= 0 ? this._minutesToBudget(Math.abs(plate_tmp)) : '-'+this._minutesToBudget(Math.abs(plate_tmp));
					scheduled_hour['left'] = left_tmp >= 0 ? this._minutesToBudget(Math.abs(left_tmp)) : '-'+this._minutesToBudget(Math.abs(left_tmp));

					if (timesheet_tmp !== 0) {
						scheduled_hour['timesheet'] = timesheet_tmp > 0 ? this._minutesToBudget(Math.abs(timesheet_tmp)) : '-'+this._minutesToBudget(Math.abs(timesheet_tmp));
					}
					scheduled_hour['remain'] = remain_tmp >= 0 ? this._minutesToBudget(Math.abs(remain_tmp)) : '-'+this._minutesToBudget(Math.abs(remain_tmp));


					const remain_hour = {};
					remain_hour['capacity'] = total_tmp >= 0 ? this._minutesToBudget(Math.abs(total_tmp)) : '-'+this._minutesToBudget(Math.abs(total_tmp));
					remain_hour['plate'] = plate_tmp >= 0 ? this._minutesToBudget(Math.abs(plate_tmp)) : '-'+this._minutesToBudget(Math.abs(plate_tmp));
					remain_hour['plate'] = left_tmp >= 0 ? this._minutesToBudget(Math.abs(left_tmp)) : '-'+this._minutesToBudget(Math.abs(left_tmp));

					if (timesheet_tmp !== 0) {
						remain_hour['timesheet'] = timesheet_tmp > 0 ? this._minutesToBudget(Math.abs(timesheet_tmp)) : '-'+this._minutesToBudget(Math.abs(timesheet_tmp));
					}
					remain_hour['remain'] = remain_tmp >= 0 ? this._minutesToBudget(Math.abs(remain_tmp)) : '-'+this._minutesToBudget(Math.abs(remain_tmp));

					progress_by_date_tmp[key] = [
						{ percent: scheduled_percent, hour: scheduled_hour, over: plate_tmp >  total_tmp },
						{ percent: remain_percent, hour: remain_hour, over: plate_tmp >  total_tmp }
					];
				}				
			}

			return progress_by_date_tmp;
		},
		_setDateRange() {
			let start_date = '';
			let end_date = '';

			const current_view = this.view_options_select.map(v => { return v.value });
			if (current_view.includes('weekends')) {
				if (this.types_select === 'day') {
					start_date = moment(this.calendar_date).format('YYYY-MM-DD');		
					end_date = moment(this.calendar_date).format('YYYY-MM-DD');
				}
				if (this.types_select === 'custom-daily') {
					start_date = moment(this.calendar_date).subtract(1, 'days').format('YYYY-MM-DD');		
					end_date = moment(this.calendar_date).add(1, 'days').format('YYYY-MM-DD');
				}
				if (this.types_select === 'week') {
					start_date = moment(this.calendar_date).weekday(1).format('YYYY-MM-DD');
					end_date = moment(this.calendar_date).weekday(7).format('YYYY-MM-DD');
				}
				if (this.types_select === 'custom-weekly') {
					start_date = moment(this.calendar_date).weekday(1).format('YYYY-MM-DD');;
					end_date = moment(this.calendar_date).weekday(14).format('YYYY-MM-DD');;
				}
				if (this.types_select === 'month') {
					start_date = moment(this.calendar_date).startOf('month').format('YYYY-MM-DD');
					end_date = moment(this.calendar_date).endOf('month').format('YYYY-MM-DD');;
				}
			} else {
				if (this.types_select === 'day') {
					start_date = moment(this.calendar_date).format('YYYY-MM-DD');		
					end_date = moment(this.calendar_date).format('YYYY-MM-DD');
				}
				if (this.types_select === 'custom-daily') {
					const start_date_tmp = moment(this.calendar_date).subtract(1, 'days').format('YYYY-MM-DD');
					start_date = this._subtractNoWeekend(start_date_tmp);
					
					const end_date_tmp = moment(this.calendar_date).add(1, 'days').format('YYYY-MM-DD');
					end_date = this._addNoWeekend(end_date_tmp);
				}
				if (this.types_select === 'week') {
					start_date = moment(this.calendar_date).weekday(1).format('YYYY-MM-DD');
					end_date = moment(this.calendar_date).weekday(5).format('YYYY-MM-DD');
				}
				if (this.types_select === 'custom-weekly') {
					start_date = moment(this.calendar_date).weekday(1).format('YYYY-MM-DD');;
					end_date = moment(this.calendar_date).weekday(12).format('YYYY-MM-DD');;
				}
				if (this.types_select === 'month') {
					start_date = moment(this.calendar_date).startOf('month').format('YYYY-MM-DD');
					end_date = moment(this.calendar_date).endOf('month').format('YYYY-MM-DD');;
				}
			}
			
			return { start_date: start_date, end_date: end_date };
		},
		_isPastTask(end_date) {
			return end_date < moment().format('YYYY-MM-DD');
		},
		_getBudgetLeft(task) {
			let budget_left = '';

			if (task.budget === 0) {
				budget_left = 'No Budget';
			} else {
				if (task.actual > task.budget) {
					const left = task.actual - task.budget;
					budget_left = `-${this._minutesToBudget(left)}`;
				} else {
					const left = task.budget - task.actual;
					budget_left = `${this._minutesToBudget(left)} left`;
				}
			}

			return budget_left;
		},
		async _getTasks(params, isAdd=false) {
			let url = "/api/tasks";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status == "OK") {
						let color_id = '';
						params.forEach(p => {
							if (p.includes('roles')) {
								const id = p.split('=');
								color_id = `${ROLES}_${id[1]}`;
							}
							if (p.includes('departments=')) {
								const id = p.split('=');
								color_id = `${DEPARTMENTS}_${id[1]}`;
							}
							if (p.includes('employees=')) {
								const id = p.split('=');
								color_id = `${ALLEMPLOYEES}_${id[1]}`;
							}
						});
						const color_txt = color_id === `${ALLEMPLOYEES}_${this.userAddressId}` ? CurrentUserEventColor: this.color_calendars[`${color_id}`];
						data.forEach(d => { 
							if (d.workdays.length === 0) {
								d['workdays'] = Default_Workday;
							}
							
							d['color'] = color_txt;
							d['color_id'] = color_id;
							if (this.completedJobPrivilege) {
								if (this.job_invalid_status_ids.includes(d.job_status.id)) {
									d['job_valid'] = false;
								} else {
									d['job_valid'] = true;
								}
							} else {
								d['job_valid'] = true;
							}
						});

						if (isAdd) {
							const existed_ids = this.tasks.map(t => { return t.id });
							data.forEach(d => {
								if (!existed_ids.includes(d.id)) {
									this.tasks.push(d);
								}
							});
						} else {
							this.tasks = data;
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_createTask(task, isCalendar, worklist) {
			const params_obj = this._buildParams(task);

			const url = "/api/tasks";
			axios
				.post(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, data, reason } = json;

					if (status == "OK") {
						if (this.progress_visible) {
							this.progress_visible = false;
						}
						this.notice_text.push(`Task ‘(${task.title})’ has been duplicated successfully`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						if (isCalendar) {
							this.initEevent();
						} else {
							this.worklists.forEach(w => {
								if (w.id === worklist.id) {
									(w['tasks']).unshift(data);
								}
							});
							this.initEevent();
						}
						
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					if (this.progress_visible) {
						this.progress_visible = false;
					}
				});
		},
		_updateTaskTime(task) {
			let url = `/api/tasks/${task.id}/set_datetime`;

			const params = [];
			const start_date = moment(`${task.start_date} ${task.start_time}`, 'Do MMM YYYY HH:mma').format('YYYYMMDD HH:mm:ss');
			params.push("start_date=" + start_date);
			const end_date = moment(`${task.end_date} ${task.end_time}`, 'Do MMM YYYY HH:mma').format('YYYYMMDD HH:mm:ss');
			params.push("end_date=" + end_date);

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, reason} = val.data;

					if (status == "OK") {
						this.initEevent();
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_updateTaskDate(task) {
			let url = `/api/tasks/${task.id}/set_dates`;

			const params = [];
			const start_date = moment(task.start_date, 'Do MMM YYYY').format('YYYY-MM-DD');
			params.push("start_date=" + start_date);

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, reason} = val.data;

					if (status == "OK") {
						this.initEevent();
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_deleteTask(id, name, isCalendar, worklist) {
			const url = `/api/tasks/${id}`;

			axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, reason} = val.data;

					if (status == "OK") {
						this.notice_text.push(`Task ‘(${name})’ has been deleted successfully.`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						if (isCalendar) {
							this.initEevent();
						} else {
							this.worklists.forEach(w => {
								if (w.id === worklist.id) {
									const tasks_tmp = w.tasks;
									const index = tasks_tmp.findIndex(d => { return d.id === id });
									if (index !== -1) {
										tasks_tmp.splice(index, 1);
									}
									w.tasks = tasks_tmp;
								}
							});
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				});
		},
		async _getTimesheets(params, is_capacity=false) {
			let url = "/api/timesheets";

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status == "OK") {
						if (this.completedJobPrivilege) {
							data.forEach(d => {
								if (this.job_invalid_status_ids.includes(d.job_status.id)) {
									d['job_valid'] = false;
								} else {
									d['job_valid'] = true;
								}
							});
						} else {
							data.forEach(d => {
								d['job_valid'] = true;
							});
						}

						if (is_capacity) {
							this.timesheet_calculate = data;
						} else {
							this.timesheets = data;
						}
						
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_updateTimesheet(timesheet) {
			const start = moment(timesheet.start, 'HH:mm:ss');
			const end = moment(timesheet.stop,  'HH:mm:ss');
			const minutes = timesheet.start ? end.diff(start, 'minutes') : timesheet.duration;

			if (minutes > (24 * 60)) {
				this.notice_text.push('Over 24 hours limit');
				this.visible_notice = true;
				this.tid = setTimeout(this._close, 2000);

				this.initEevent();
				return;
			}

			let url = "/api/timesheets";

			const params = [];
			params.push("employees=" + this.userAddressId);
			params.push("start_date=" + timesheet.date);
			params.push("end_date=" + timesheet.date);
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status == "OK") {
						let existed_minutes = 0;
						const data_filter = data.filter(d => { return d.id !== timesheet.id });
						data_filter.forEach(d => {
							existed_minutes += d.duration;
						});

						if (minutes + existed_minutes <= 24 * 60) {
							this._updateTimesheetAPI(timesheet);
							
						} else {
							this.notice_color = '#ffc107';
							this.notice_text.push(`Over 24 hours limit, ${existed_minutes} minute(s) existed`);
							this.visible_notice = true;
							this.tid = setTimeout(this._close, 2000);

							this.initEevent();
							return;
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});			
		},
		_updateTimesheetAPI(timesheet) {
			this.finish_timesheet_flag = true;
			const url = `/api/timesheets/${timesheet.id}`;

			const params = {};
			params['acoc'] = timesheet.acoc;
			/** JBX will not support Safari version 14.0 */
			params['date'] = moment(timesheet.date).format('YYYYMMDD');
			params['duration'] = timesheet.duration;
			params['notes'] = timesheet.notes;
			params['phase_id'] = timesheet.phase.id;
			if (timesheet.task) {
				params['task_id'] = timesheet.task.id;
			} else {
				params['kind_id'] = timesheet.kind.id;
			}

			if (timesheet.start && timesheet.stop) {
				params['start_time'] = 	timesheet.start;
				params['end_time'] = 	timesheet.stop;
			}

			axios
				.put(url, params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
						this.initEevent();
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_deleteTimesheet(id, name) {
			const url = `/api/timesheets/${id}`;

			axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, reason} = val.data;

					if (status == "OK") {
						this.notice_text.push(`Timesheet ‘(${name})’ has been deleted successfully.`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						this.initEevent();
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				});
		},
		_updateLeave(leave) {
			const start_date = leave.all_day ? moment(leave.start_datetime).format('YYYY-MM-DD') : moment(leave.start_datetime).format('YYYY-MM-DD HH:mm:ss');
			const end_date = leave.all_day ? moment(leave.end_datetime).format('YYYY-MM-DD') : moment(leave.end_datetime).format('YYYY-MM-DD HH:mm:ss');

			const params = {
				event_type_id: leave.event_type.id,
				description: leave.description,
				all_day: leave.all_day,
				start_date: start_date,
				end_date: end_date,
				duration: 0,
				employee_id: leave.employee.id,
				timezone: this.user_timezone
			};

			const url = `/api/leave/${leave.id}`;

			axios
				.put(url, params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, reason } = json;

					if (status == "OK") {
						this.initEevent();
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});	
		},
		_deleteLeave(id, name) {
			const url = `/api/leave/${id}`;

			axios
				.delete(url, {}, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.notice_text.push(`Leave ‘(${name})’ has been deleted successfully.`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						this.initEevent();
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_approveLeave(id, name, is_public_holiday=false) {
			const url = `/api/leave/${id}/approve`;

			axios
				.get(url, {}, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						if (is_public_holiday) {
							this.notice_text.push(`Public Holiday ‘(${name})’ has been approved successfully.`);
						} else {
							this.notice_text.push(`Leave ‘(${name})’ has been approved successfully.`);
						}
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						this.initEevent();
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_unapproveLeave(id, name, is_public_holiday=false) {
			const url = `/api/leave/${id}/unapprove`;

			axios
				.get(url, {}, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						if (is_public_holiday) {
							this.notice_text.push(`Public Holiday ‘(${name})’ has been unapproved successfully.`);

						} else {
							this.notice_text.push(`Leave ‘(${name})’ has been unapproved successfully.`);
						}
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						this.initEevent();
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async _getItems(params) {
			let url = "/api/items";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status == "OK") {
						data.forEach(d => {
							d['job_valid'] = true;
						});
						this.items = data;	
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async _updateItem(item) {
			const params_charge = this._getChargeRateParams(item);

			let charge_rate = 0;
			await this._getChargeRate(params_charge).then(val => {
				charge_rate = val;				
			})
				.catch(msg => {
					this.error_msg = msg.message;
				});

			const url = `/api/items/${item.id}`;
			const params = {};
			params['date'] = moment(item.date).format('YYYYMMDD');
			params['units'] = item.units;
			params['phase_id'] = item.phase.id;
			params['kind_id'] = item.kind.id;
			params['currency_id'] = item.value_currency.id;
			params['item_value'] = charge_rate * item.units;

			axios
				.put(url, params, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const {status, reason} = val.data;

					if (status == "OK") {
						this.initEevent();
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_deleteItem(id) {
			const url = `/api/items/${id}`;

			axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, reason} = val.data;

					if (status == "OK") {
						this.notice_text.push(`Item has been deleted successfully.`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						this.initEevent();
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				});
		},
		async _getEvents(params, current_view) {
			let url = "/api/events";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if (typeof(json) === 'string') {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status === "OK") {
						data.forEach(d => {
							d['job_valid'] = true;
						});

						if (current_view.includes(Event_Events)) {
							this.other_events = data.filter(d => { return d.type !== config.public_holiday_type && d.leave_type === Not_Leave });
						} else {
							this.other_events = [];
						}

						if (current_view.includes(Event_Holiday)) {
							this.holidays = data.filter(d => { return d.type === config.public_holiday_type && d.leave_type !== Not_Leave });
						} else {
							this.holidays = [];
						}

						if (current_view.includes(Event_Leave)) {
							this.leaves = data.filter(d => { return d.type !== config.public_holiday_type && d.leave_type !== Not_Leave });
						} else {
							this.leaves = [];
						}

					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async _updateEvent(event) {
			const url = `/api/events/${event.id}`;

			const params = {};
			params['event_type_id'] = event.event_type.id;
			params['description'] = event.description;
			params['all_day'] = event.all_day;
			params['timezone'] = this.user_timezone;

			params['start_date'] = moment(event.start_datetime, 'YYYYMMDD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss Z');
			params['end_date'] = moment(event.end_datetime, 'YYYYMMDD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss Z');
			
			if (!event.all_day) {
				const start_time = moment(event.start_datetime, 'YYYYMMDD HH:mm:ss');
				const end_time = moment(event.end_datetime, 'YYYYMMDD HH:mm:ss');
				const duration = end_time.diff(start_time, 'minutes');
				params['duration'] = duration;
			}
			if (event.event_type.links === Mandatory || event.event_type.links === Mandatory_Job || event.client) {
				if (event.client) {
					params['abook_id'] = event.client.id;
				}
			}
			if (event.event_type.links === Mandatory_Job || event.job) {
				params['job_id'] = event.job.id;
			}
			if (event.event_type.contact_needed && event.contact) {
				params['contact_id'] = event.contact.id;
			}
			params['employee_id'] = event.employee_id;
			params['plan_type'] = event.event_type.plan_type;
			params['notes'] = event.notes;
			params['notes_fmt'] = event.notes_fmt;

			params['is_ticked'] = event.is_ticked;
			params['repeat_unit'] = event.repeat_unit;
			params['repeat_value'] = event.repeat_value;
			
			const invitee_list = [];
			event.invitees.forEach(invitee => {
				const invitee_obj = {
					id: invitee.id,
					accepted: invitee.accepted,
					is_deleted: false,
					pay_processed: false,
					send_email: false,
					email_id: invitee.email_id,
					is_organiser: invitee.is_organiser
				}

				if (invitee.employee.contact_id) {
					invitee_obj['contact_id'] = invitee.employee.contact_id;
				} else {
					invitee_obj['employee_id'] = invitee.employee.id;
				}

				invitee_list.push(invitee_obj);
			});
			params['invitees'] = invitee_list;
			params['iteration'] = event.iteration;
			params['repeat_mode'] = 1;
			

			await axios
				.put(url, params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if (typeof(json) === 'string') {
						json = JSON.parse(json);
					}

					const { status, reason } = json;

					if (status === "OK") {
						this.initEevent();
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_deleteEvent(id, name, repeat, mode, iteration) {
			const params = [];
			if (repeat !== 0) {
				params.push('repeat_mode=' + mode);
				params.push('iteration=' + iteration);
			}

			let url = `/api/events/${id}`;
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.delete(url, {}, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.notice_text.push(`Event ‘(${name})’ has been deleted successfully.`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						this.initEevent();
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_deleteHoliday(id, name) {
			const url = `/api/leave/${id}`;

			axios
				.delete(url, {}, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.notice_text.push(`Event ‘(${name})’ has been deleted successfully.`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						this.initEevent();
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		//?? change the name? Tasklist => worklist/
		_deleteTasklist(id, name) {
			const url = `/api/worklists/${id}`;

			axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, reason} = val.data;

					if (status == "OK") {
						this.notice_text.push(`Tasklist ‘${name}’ has been successfully deleted.`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						const index = this.worklists.findIndex(t => { return t.id === id });
						this.worklists.splice(index, 1);

						this.delete_item = null;
						this.$store.dispatch('update_pinned_tasks_worklists');
						
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				});
		},
		_getTasklist(worklist_id, worklist_setting) {
			this.loading_tasklist = worklist_id;
			const params = this._setParams(worklist_setting);
			const filter_params = this._setFilterParams(worklist_setting);

			let url = "/api/tasks";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status == "OK") {
						let data_filter = []
						if (filter_params.length !== 0) {
							data_filter = this._filterDate(data, filter_params)
						}

						const job_items_tmp = data_filter.map(d => {
							const obj = {};
							obj['id'] = d.job.id;
							obj['display_name'] = `${d.job.code} - ${d.job.name}`;
							return obj;
						});
						const client_items_tmp = data_filter.map(d => {
							const obj = {};
							obj['id'] = d.client.id;
							obj['display_name'] = d.client.name;
							return obj;
						});

						const map_job = new Map();
						job_items_tmp.forEach(j => {
							if (!map_job.has(j.id)) {
								map_job.set(j.id, j);
							}
						});
						const map_client = new Map();
						client_items_tmp.forEach(j => {
							if (!map_client.has(j.id)) {
								map_client.set(j.id, j);
							}
						});

						this.job_items = [...map_job.values()];
						this.job_selected = this.job_items;

						this.client_items = [...map_client.values()];
						this.client_selected = this.client_items;
						
						const active_status_tmp = this.statusses.filter(s => { return s.type === ACTIVE_STATUS });
						const active_ids = active_status_tmp.map(s => { return s.id });

						let statusses_filter = params.filter(p => { return p.startsWith('statusses') });
						statusses_filter = statusses_filter.length === 0 ? [`statusses=${active_ids}`] : statusses_filter;
						const statusses_arr = statusses_filter[0].split('=');
						const statusses_type_arr_tmp = statusses_arr[1].split(',');
						const statusses_type_arr = statusses_type_arr_tmp.map(s => { return Number(s)});
						this.statuses_selected = this.statusses.filter(s => { return statusses_type_arr.includes(s.id) });

						data_filter.forEach(d => { 
							d['type'] = Event_Task;

							if (this.completedJobPrivilege) {
								if (this.job_invalid_status_ids.includes(d.job_status.id)) {
									d['job_valid'] = false;
								} else {
									d['job_valid'] = true;
								}
							} else {
								d['job_valid'] = true;
							}

						});
						this.worklists.forEach(w => {
							if (w.id === worklist_id) {
								w.tasks = data_filter;
								w.tasksOrigin = data_filter;
							}
						});

						this.loading_tasklist = 0;
					} else {
						this.error_msg = reason;
						this.loading_tasklist = 0;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading_tasklist = 0;
				}).finally(() => {
					this.loading_tasklist = 0;
				});
		},
		_searchTasks(worklist_id, settings) {
			const params = this._setParams(settings);
			const filter_params = this._setFilterParams(settings);
			const settings_str = JSON.stringify(settings);

			let url = "/api/tasks";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status == "OK") {
						let data_filter = []
						if (filter_params.length !== 0) {
							data_filter = this._filterDate(data, filter_params)
						}

						if (worklist_id === 0) {
							const worklist_item_obj = {
								id: `0_${new Date().getTime()}`,
								class: TASKLIST_CLASS,
								name: 'Unsaved list',
								settings: settings,
								is_dynamic: true,
								tasks: data_filter,
								tasksOrigin: data_filter
							};
							this.worklists.unshift(worklist_item_obj);
							if (!this.current_unsaved_ids.includes(worklist_item_obj.id)) {
								this.current_unsaved_ids.push(worklist_item_obj.id);
							}
						} else {
							this.worklists.forEach(w => {
								if (w.id === worklist_id) {
									w.id = `${worklist_id}`;
									w.settings = settings_str,
									w.tasks = data_filter;
									w.tasksOrigin = data_filter;

									this.worklist_open_id = w.id;
								} 
							});

							if (!this.current_unsaved_ids.includes(`${worklist_id}`)) {
								this.current_unsaved_ids.push(`${worklist_id}`);
							}
						}

					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				}).finally(() => {
					if (this.loading_key !== -1) {
						this.loading_key = -1;
					}
				});
		},
		_loadWorklistItem(id) {
			const url = `/api/worklists/${id}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const {  status, data, reason } = json;

					if (status == "OK") {
						this.share_item = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_pinTasklist(item, enabled) {
			const url = `/api/worklists/${item.id}/pinned`;

			const param = {enabled: enabled }

			axios
				.put(url, param, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then(val =>  {
					const {status, reason} = val.data;

					if (status == "OK") {
						if (enabled) {
							this.notice_text.push(`Tasklist ‘${item.name}’ has been pinned.`);
						} else {
							this.notice_text.push(`Tasklist ‘${item.name}’ has been unpinned.`);
						}
						
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						this.$store.dispatch('update_pinned_tasks_worklists');

						const tasklist_tmp = [];
						this.worklists.forEach(t => {
							if (t.id === item.id) {
								t['is_pinned'] = enabled;
								tasklist_tmp.push(t);
							} else {
								tasklist_tmp.push(t);
							}
						});

						this.worklists = tasklist_tmp;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async _updateTasklist(id, owner, param) {
			const url = `/api/worklists/${id}`;
			await axios
				.put(url, param, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const tasklist_tmp = [];
						this.worklists.forEach(t => {
							if (t.id === id) {
								data['tasks'] = t.tasks;
								data['tasksOrigin'] = t.tasksOrigin;
								data['is_open'] = t.is_open;
								tasklist_tmp.push(data);
							} else {
								tasklist_tmp.push(t);
							}
						});
						this.worklists = tasklist_tmp;

						if (this.current_unsaved_ids.length !== 0) {
							this.current_unsaved_ids = this.current_unsaved_ids.filter(current_unsaved_id => { return current_unsaved_id !== id});
						}

						this.notice_text.push(`${data.name} has been changed successfully`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
							
						this.edit_id = -1;
						if (data.is_pinned) {
							this.$store.dispatch('update_pinned_tasks_worklists');
						}

						this.unsaved_visible = false;

					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async _createTasklist(param) {
			const url = '/api/worklists';

			await axios
				.post(url, param, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						data['is_open'] = false;
						data['tasks'] = [];
						data['tasksOrigin'] = [];

						const tasklist_temp = this.worklists.filter(t => { return t.id !== this.save_as_item.id });
						tasklist_temp.unshift(data);
						this.worklists = tasklist_temp;

						if (this.current_unsaved_ids.length !== 0) {
							this.current_unsaved_ids = this.current_unsaved_ids.filter(c => { return c !== this.save_as_item.id });
						}

						this.notice_text.push(`Tasklist ‘${param.name}’ has been created.`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						this.save_as_visible = false;
						this.save_as_item = null;

						this.unsaved_visible = false;

					} else {
						thius.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_buildParams(task) {
			const params_obj = {};
			params_obj['description'] = task.description;
			params_obj['parent_id'] = task.parent_id;
			params_obj['text_color'] = TEXT_COLOR,
			params_obj['phase_id'] = task.phase.id;
			params_obj['kind_id'] = task.kind.id;
			params_obj['status_id'] = task.status.id;
			params_obj['priority'] = task.priority;
			params_obj['acoc'] = 0;
			params_obj['on_planning'] = true;
			params_obj['on_timeline'] = true;
			params_obj['has_time'] = task.has_time;
			params_obj['is_suggested'] = task.is_suggested;
			params_obj['budget_type'] = task.budget_type;
			params_obj['units'] = task.units;
			params_obj['value'] = task.value;
			params_obj['charge_rate'] = task.charge_rate;

			const assigned_arr = [];
			task.For.forEach(f => {
				const obj = {};
				obj['mode'] = f.Type;
				if (f.AbookId) {
					obj['abook_id'] = f.AbookId;
				}
				if (f.RoleId) {
					obj['role_id'] = f.RoleId;
				}
				if (f.DepartmentId) {
					obj['department_id'] = f.DepartmentId;
				}
				assigned_arr.push(obj);
			});
			params_obj['assigned'] = assigned_arr;

			const day1 = moment(task.start_datetime);
			const day2 = moment(task.end_datetime);
			const days = day2.diff(day1, 'day') + 1;
			params_obj['days'] = days;

			const start_date_time_tmp = moment(`${task.start_date} ${task.start_time}`, 'Do MMM YYYY HH:mma');
			const end_date_time_tmp = moment(`${task.end_date} ${task.end_time}`, 'Do MMM YYYY HH:mma');

			params_obj['start'] = task.has_time ? start_date_time_tmp.format('YYYYMMDD HH:mm:ss') : moment(task.start_date, 'Do MMM YYYY').format('YYYYMMDD');
			params_obj['end'] = task.has_time ? end_date_time_tmp.format('YYYYMMDD HH:mm:ss') : moment(task.end_date, 'Do MMM YYYY').format('YYYYMMDD');

			return params_obj;
		},
		_isDuringDate(startDateStr, endDateStr, curDateStr) {
			const curDate = new Date(curDateStr);
			const startDate = new Date(startDateStr);
			const endDate = new Date(endDateStr);
			if (curDate >= startDate && curDate <= endDate) {
				return true;
			}
			return false;
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];
			this.error_msg = '';
		},
		_minutesToBudget(value, full_display=false) {
			let result = '0';
			const isNegtive = value < 0 ? true : false;

			const value_tmp = Math.abs(value);
			
			if (value_tmp < 60 && value_tmp >= 0) {
				result = `${value_tmp}m`;
			}

			if (value_tmp >= 60) {
				const hours = Math.floor(value_tmp / 60);
				const minutes =  Math.floor(value_tmp - (hours * 60));
				result = minutes > 0 ? `${hours}h ${minutes}m` : (full_display ? `${hours}h 0m`: `${hours}h`);
			}

			return isNegtive ? '-'+result : result;
		},
		_setParams(settings) {
			const settings_obj = settings && typeof(settings) === 'string' ? JSON.parse(settings) : settings;
			
			const params = [];

			/*  if no assign_mode, assign_mode=0, 0 = you */
			const assign_mode = settings_obj.assign_mode ? settings_obj.assign_mode : 0;
			params.push("assign_mode=" + assign_mode);

			/*  if no date_mode, date_mode=1, 1 = next 7 days */
			const date_mode = settings_obj.date_mode ? settings_obj.date_mode : 1;
			params.push("date_mode=" + date_mode);

			/*  if no budget_types, budget_types=[0, 1, 2, 3], 0=No units/value, 1=Value only, 2=Minutes + Value, 3=Units + Value */
			const budget_types = settings_obj.budget_types ? settings_obj.budget_types : [0, 1, 2, 3];
			params.push("budget_types=" + budget_types);

			if (settings_obj.statusses) {
				params.push("statusses=" + settings_obj.statusses);
			}
			if (settings_obj.priorities) {
				params.push("priorities=" + settings_obj.priorities);
			}
			if (settings_obj.date_mode && settings_obj.date_mode === 2) {
				if (settings_obj.start_date && settings_obj.start_date.length !== 0) {
					params.push("start_date=" + encodeURIComponent(settings_obj.start_date));
				}
				if (settings_obj.end_date && settings_obj.end_date.length !== 0) {
					params.push("end_date=" + encodeURIComponent(settings_obj.end_date));
				}
			}
			if (settings_obj.departments && settings_obj.departments.length !== 0) {
				params.push("departments=" + settings_obj.departments);
			}
			if (settings_obj.roles && settings_obj.roles.length !== 0) {
				params.push("roles=" + settings_obj.roles);
			}
			if (settings_obj.employees && settings_obj.employees.length !== 0) {
				params.push("employees=" + settings_obj.employees);
			}
			
			return params
		},
		_setFilterParams(settings) {
			const filter_params = [];

			const settings_obj = settings && typeof(settings) === 'string' ? JSON.parse(settings) : settings;

			if (typeof(settings_obj.suggested_mode) === 'undefined' || settings_obj.suggested_mode === null) {
				filter_params.push({ date_type: [Date_Options_Suggested, Date_Options_Actual] });
			} else {
				filter_params.push({ date_type: settings_obj.date_type });
			}
			
			return filter_params;
		},
		_filterDate(data, filter_params) {
			let data_filter = [];

			filter_params.forEach(obj => {
				for (const [key, value] of Object.entries(obj)) {
					if (key === 'date_type') {
						if (value.length === 1) {
							if (value[0] === Date_Options_Suggested) {
								data_filter = data.filter(d => { return d.is_suggested === true });
							}
							if (value[0] === Date_Options_Actual) {
								const data_actual = data.filter(d => { return d.is_suggested === false });
								data_filter = data_actual.filter(d => { return d.date !== null });
							} 
							if (value[0] === Date_Options_No) {
								data_filter = data.filter(d => { return d.date === null });
							} 
						}
						

						if (value.length === 2) {
							if (value.includes(Date_Options_No) && value.includes(Date_Options_Suggested)) {
								const data_suggested = data.filter(d => { return d.is_suggested === true });
								const data_no_date = data.filter(d => { return d.date === null });
								data_filter = [...data_suggested, ... data_no_date];
							}
							if (value.includes(Date_Options_No) && value.includes(Date_Options_Actual)) {
								const data_actual = data.filter(d => { return d.is_suggested === false });
								data_filter = data_actual;
							}
							if (value.includes(Date_Options_Suggested) && value.includes(Date_Options_Actual)) {
								const data_suggested = data.filter(d => { return d.is_suggested === true });
								const data_actual = data.filter(d => { return d.is_suggested === false });
								/** default including 'no dates' */
								data_filter = [...data_suggested, ...data_actual];
							}
						}

						if (value.length === 3) {
							data_filter = data;
						}
					}
				}
			});

			return data_filter;
		},
		_subtractNoWeekend(current_day) {
			let start_date = '';
			if (moment(current_day).weekday() === 0 || moment(current_day).weekday() === 6) {
				const start_date_tmp = moment(current_day).subtract(1, 'days').format('YYYY-MM-DD');
				start_date = this._subtractNoWeekend(start_date_tmp);
			} else {
				start_date = current_day;
			}
			return start_date;
		},
		_addNoWeekend(current_day) {
			let end_date = '';
			if (moment(current_day).weekday() === 0 || moment(current_day).weekday() === 6) {
				const end_date_tmp = moment(current_day).add(1, 'days').format('YYYY-MM-DD');
				end_date = this._addNoWeekend(end_date_tmp);
			} else {
				end_date = current_day;
			}
			return end_date;
		},
		_getRandomColor() {
			const colorAngle = Math.floor(Math.random()*360);
			const color = `hsla(${colorAngle}, ${SATURATION}%, ${LIGHTNESS}%, ${ALPHA})`;
			return color;

			/** rgba color random */
			// const r = Math.floor(Math.random()*255);
			// const g = Math.floor(Math.random()*255);
			// const b = Math.floor(Math.random()*255);
			// const color = 'rgba('+ r +','+ g +','+ b +',0.8)';
			// return color;
		},
		_isWorkDay(current_day, workdays) {
			let end_date = moment(current_day).format('YYYY-MM-DD');

			if (!workdays.includes(end_date) && workdays.length !== 0 && workdays[workdays.length -1] >= end_date) {
				const end_date_tmp = moment(end_date).add(1, 'days').format('YYYY-MM-DD');
				end_date = this._isWorkDay(end_date_tmp, workdays);
			}

			return end_date;
		},
		formatColor(background_color) {
			const color_res = colorContrastChecker(background_color);
			return `${color_res}`;
		},
		_getChargeRateParams(item) {
			const params = [];
			if (item.kind) {
				params.push('kind_id=' + item.kind.id);
			}

			if (item.currency) {
				params.push('currency_id=' + item.currency.id);
			}
			
			if (this.date && this.date.length !== 0) {
				params.push('date=' + this.date);
			}

			if (this.job) {
				params.push('job_id=' + this.job.id);
			}

			return params;
		},
		_getChargeRate(params) {
			return new Promise((resolve,reject) => {
				let url = "/api/config/rates/chargerate";
				if (params.length > 0) {
					url+= "?" + params.join('&');
				}
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const {status, data, reason } = val.data;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}	
					})
					.catch((e) => {
						reject(e);
					});
			});
		},
		_getFilterStatus() {
			const statusesFiltered_tmp = [];
			this.view_options_select.forEach(s => {
				if (s.value === Event_Task_Active) {
					this.statusses.forEach(status => {
						if (status.type === config.status_active_type) {
							statusesFiltered_tmp.push(status.id);
						}
					});
				}
				if (s.value === Event_Task_Completed) {
					this.statusses.forEach(status => {
						if (status.type === config.status_completed_type) {
							statusesFiltered_tmp.push(status.id);
						}
					});
				}
			});

			return  statusesFiltered_tmp;
		},
		errorMessageFormat(msg) {
			if (msg.length !== 0) {
				this.tid = setTimeout(this._close, 5000);
				this.tid = setTimeout(this.initEevent, 5500);

				if (msg.includes(config.server_msge_flag)) {
					const msg_arr = msg.split(config.server_msge_flag);
					return msg_arr[1];
				} else {
					return msg;
				}				
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.calendar-container {
	display: flex;
  flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: stretch;
}
.data-picker-mobile-container {
	background: #FAFAFA;
	max-width: 100%;
	height: 100%;
}
.date-picker {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
	height: 100%;
  background: #FAFAFA;
}
.date-picker-top {
	display: flex;
  flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	width: 100%;
}
.date-picker-btn {
	display: flex;
  flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;

	font-family: 'Roboto';
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 36px;
	color: #82899B;
	&:hover {
		cursor: pointer;
	}
}
.date-picker-task-wrap {
  overflow: auto;
}
.date-picker-task-container {
  height: 99%;
}
.date-picker-task-row {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;

	border-radius: 4px;
	height: 40px;
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 18px;
	
	&:hover {
		cursor: pointer;
	}
}
.data-picker-task-name-text {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}
.date-picker-task-row-left {
	display: flex;
  flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	width: 80%;
}
.date-picker-task-row-grey {
	background: #E8EAEC;
	color: rgba(25, 42, 62, 0.7);
}
.date-picker-task-row-red {
	background: rgba(244, 82, 82, 0.2);
	color: #F45252;
}
.date-picker-search-title {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 36px;
	color: rgba(25, 42, 62, 0.7);
}
.date-picker-filter {
	display: flex;
  flex-flow: column nowrap;
	justify-content: center;
	align-items: flex-start;
	width: 100%;
}
.date-picker-filter-item {
	display: flex;
  flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	width: 100%;
}
.date-picker-filter-checkbox {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: rgba(25, 42, 62, 0.7);
}
.calendar {
	height: 100%;
}
.calendar-toolbar {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.calendar-date {
  display: flex;
  flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
}
.calendar-options {
  display: flex;
  flex-flow: row nowrap;
	justify-content: flex-end;
	align-items: center;
}
.item-container {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
	border-radius: 2px;
	height: 100%;
	width: 100%;
	padding: 4px;

	user-select: none;
}
.item-container-inside {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: flex-start;
	height: 100%;
	width: 100%;
	overflow: hidden;
}
.item-container-icons {
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
}
.task-item-container {
	border: 1px solid rgba(25, 42, 62, 0.3);
}
// .task-item-container-able {
// 	color: #192A3E;  
// }
// .task-item-container-disable {
// 	opacity: 0.5;
// 	color: #192A3E;
// }
.timesheet-item-container {
	border: 1px solid #3A7E9F;
	background-color: #E1EFF5;
	color: #3A7E9F;
}
.leave-item-container {
	border: 1px solid rgba(255, 185, 70, 0.5);
	background-color: #C18014;
	color: #FFFFFF;
}
.holiday-item-container {
	border: 1px solid #FFB946;
	background-color: #FFFFFF;
	color: #192A3E;
}
.leave-item-container-pending {
	opacity: 0.5;
}
.item-item-container {
	border: 1px solid #0012B1;
	background-color: #F2F3FB;
	color: #0012B1;
}
.event-item-container {
	border: 1px solid #81CC00;
	background-color: #FFFFFF;
	color: #192A3E;
}
.text-container {
  display: flex;
	flex-flow: column nowrap;
	align-items: flex-start;
	justify-content: center;
	width: 100%;	
	overflow: hidden;
}
.icon-container {
	display: flex;
	flex-flow: column nowrap;
	align-items: flex-start;
}
.text-title {
	width: 100%;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
	line-height: 14px;
	letter-spacing: 0.4px;

	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.text-name-style {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 12px;
	letter-spacing: 0.4px;
}
.text-name {
	width: 100%;
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 12px;
	letter-spacing: 0.4px;

	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.text-name-full {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 12px;
	letter-spacing: 0.4px;
}
.task-card {
  max-width: 300px;
  min-width: 280px;
}
.drag-able {
	cursor: move;
}
.drag-disable {
	cursor: not-allowed;
}
.menu-disable {
	&:hover {
		cursor: default;
	}
}
.corner {
	width: 0;
	height: 0;
	border-top: 12px solid red;
	border-left: 12px solid transparent;
	position: absolute;
  top: 1px;
  right: 1px;
}
.corner-grey {
	width: 0;
	height: 0;
	border-top: 12px solid #82899B;
	border-left: 12px solid transparent;
	position: absolute;
  top: 1px;
  right: 1px;
}
.task-item-text-title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.6px;
	padding: 4px 0;
}

.task-item-text-title-oneline {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.task-menu-item {
	&:hover {
		background-color: #E8EAEC;
	}
}
.task-menu-item-able {
	&:hover {
		cursor: pointer;
	}
}
.timesheet-text-color {
	color: #65A3C1;
}
.leave-text-color {
	color: #C18014;
}
.public-text-color {
	color: #192A3E;
}
.item-text-color {
	color: #0012B1;
}
.event-text-color {
	color: #609800;
}
.task-opened-color {
	color: #81CC00;
}
.task-new-color {
	color: #F45252;
}
.current-time {
  height: 2px;
  background-color: #81CC00;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: '';
    position: absolute;
    background-color: #81CC00;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}
.v-event-draggable {
  padding-left: 6px;
}
.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid #000000;
    border-bottom: 1px solid #000000;
    width: 32px;
    margin-left: -16px;
    opacity: 0.8;
    content: '';
  }

  &:hover::after {
    display: block;
  }
}
.date-title {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	line-height: 32px;
	letter-spacing: -0.5px;
	color: #192A3E;
}
.date-title-xs {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 32px;
	letter-spacing: -0.15px;
	color: #192A3E;
}
.date-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 32px;
	letter-spacing: 0.5px;
	color: #82899B;
}
.visible-scrollbar {
  display: block;
  width: 10em;
  overflow: auto;
  height: 2em;
  padding: 1em;
  margin: 1em auto;
  outline: 2px dashed cornflowerblue;
}

/** for Windows scrollbar */
::-webkit-scrollbar{
  background-color: transparent;
	padding: 2px;
}
::-webkit-scrollbar-thumb{
  background-color: transparent;
  border-radius: 8px;
	margin: 2px;
	border: 2px solid transparent;
  background-clip: content-box;
}

body{
  overflow: overlay;
}

$tooltip-background-color: red;

::v-deep {
  .theme--light.v-picker__body  {
    background: #FAFAFA;
  }
	.v-event-more {
		font-size: 14px;
	}
	.v-calendar-daily__head {
		height: 268px;
		// overflow-y: auto;
		overflow: overlay;
	}
	.v-calendar-daily_head-day {
		border-bottom: none;
	}
	.v-date-picker-table__current {
    color: #FFFFFF !important;
		background-color: rgb(129, 204, 0) !important;
	}

	// .client.v-text-field--outlined fieldset {
	// 	border-color: #81CC00 !important;
	// }
	// .client.theme--light.v-input input, .theme--light.v-input textarea {
	// 	color: #81CC00;
	// }
	
}
</style>
